// _src/js/lib/attribution.js
// First-touch marketing attribution. All three layouts load this bundle as
// <script type="module">, so this runs on every page load of every template.
//
// First touch wins and is never overwritten. Last-touch would credit the
// customer who discovered us on Instagram and later googled our name to
// "google / organic", which is precisely the attribution error this exists to
// avoid.
(function () {
  var STORAGE_KEY = 'pr_attribution';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // 90 days
  // Only these named params are read. Never store the query string wholesale —
  // it can carry email addresses and auth tokens.
  var PARAM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'];

  try {
    var existing = null;
    try {
      existing = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      existing = null; // malformed — treat as absent and recapture
    }

    if (existing && existing.capturedAt) {
      var age = Date.now() - new Date(existing.capturedAt).getTime();
      if (!isNaN(age) && age >= 0 && age < MAX_AGE_MS) {
        return; // first touch already recorded and still within window
      }
    }

    var params = new URLSearchParams(window.location.search);
    var record = {};
    for (var i = 0; i < PARAM_KEYS.length; i++) {
      record[PARAM_KEYS[i]] = params.get(PARAM_KEYS[i]) || null;
    }

    // An internal page-to-page navigation is not an acquisition source, and only
    // the origin is kept (never the path or query string) so an inbound URL's
    // query string cannot carry PII into storage.
    var referrer = document.referrer || null;
    if (referrer) {
      try {
        var referrerUrl = new URL(referrer);
        referrer = referrerUrl.hostname === window.location.hostname ? null : referrerUrl.origin;
      } catch (e) {
        referrer = null;
      }
    }

    record.referrer = referrer;
    record.landingPath = window.location.pathname;
    record.capturedAt = new Date().toISOString();

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch (e) {
    // Private browsing or storage disabled. Attribution is simply absent —
    // this must never break the theme.
  }
})();

// Read stored attribution for submission. Returns null on anything unexpected;
// a quote submission must never fail over attribution.
function readAttribution() {
  try {
    var raw = window.localStorage.getItem('pr_attribution');
    if (!raw) return null;
    var parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (e) {
    return null;
  }
}

// node_modules/wicg-inert/dist/inert.esm.js
var _createClass = /* @__PURE__ */ function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
(function() {
  if (typeof window === "undefined" || typeof Element === "undefined") {
    return;
  }
  var slice = Array.prototype.slice;
  var matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
  var _focusableElementsString = ["a[href]", "area[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", "details", "summary", "iframe", "object", "embed", "video", "[contenteditable]"].join(",");
  var InertRoot = function() {
    function InertRoot2(rootElement, inertManager2) {
      _classCallCheck(this, InertRoot2);
      this._inertManager = inertManager2;
      this._rootElement = rootElement;
      this._managedNodes = /* @__PURE__ */ new Set();
      if (this._rootElement.hasAttribute("aria-hidden")) {
        this._savedAriaHidden = this._rootElement.getAttribute("aria-hidden");
      } else {
        this._savedAriaHidden = null;
      }
      this._rootElement.setAttribute("aria-hidden", "true");
      this._makeSubtreeUnfocusable(this._rootElement);
      this._observer = new MutationObserver(this._onMutation.bind(this));
      this._observer.observe(this._rootElement, { attributes: true, childList: true, subtree: true });
    }
    _createClass(InertRoot2, [{
      key: "destructor",
      value: function destructor() {
        this._observer.disconnect();
        if (this._rootElement) {
          if (this._savedAriaHidden !== null) {
            this._rootElement.setAttribute("aria-hidden", this._savedAriaHidden);
          } else {
            this._rootElement.removeAttribute("aria-hidden");
          }
        }
        this._managedNodes.forEach(function(inertNode) {
          this._unmanageNode(inertNode.node);
        }, this);
        this._observer = /** @type {?} */
        null;
        this._rootElement = /** @type {?} */
        null;
        this._managedNodes = /** @type {?} */
        null;
        this._inertManager = /** @type {?} */
        null;
      }
      /**
       * @return {!Set<!InertNode>} A copy of this InertRoot's managed nodes set.
       */
    }, {
      key: "_makeSubtreeUnfocusable",
      /**
       * @param {!Node} startNode
       */
      value: function _makeSubtreeUnfocusable(startNode) {
        var _this2 = this;
        composedTreeWalk(startNode, function(node2) {
          return _this2._visitNode(node2);
        });
        var activeElement = document.activeElement;
        if (!document.body.contains(startNode)) {
          var node = startNode;
          var root = void 0;
          while (node) {
            if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
              root = /** @type {!ShadowRoot} */
              node;
              break;
            }
            node = node.parentNode;
          }
          if (root) {
            activeElement = root.activeElement;
          }
        }
        if (startNode.contains(activeElement)) {
          activeElement.blur();
          if (activeElement === document.activeElement) {
            document.body.focus();
          }
        }
      }
      /**
       * @param {!Node} node
       */
    }, {
      key: "_visitNode",
      value: function _visitNode(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }
        var element = (
          /** @type {!HTMLElement} */
          node
        );
        if (element !== this._rootElement && element.hasAttribute("inert")) {
          this._adoptInertRoot(element);
        }
        if (matches.call(element, _focusableElementsString) || element.hasAttribute("tabindex")) {
          this._manageNode(element);
        }
      }
      /**
       * Register the given node with this InertRoot and with InertManager.
       * @param {!Node} node
       */
    }, {
      key: "_manageNode",
      value: function _manageNode(node) {
        var inertNode = this._inertManager.register(node, this);
        this._managedNodes.add(inertNode);
      }
      /**
       * Unregister the given node with this InertRoot and with InertManager.
       * @param {!Node} node
       */
    }, {
      key: "_unmanageNode",
      value: function _unmanageNode(node) {
        var inertNode = this._inertManager.deregister(node, this);
        if (inertNode) {
          this._managedNodes["delete"](inertNode);
        }
      }
      /**
       * Unregister the entire subtree starting at `startNode`.
       * @param {!Node} startNode
       */
    }, {
      key: "_unmanageSubtree",
      value: function _unmanageSubtree(startNode) {
        var _this3 = this;
        composedTreeWalk(startNode, function(node) {
          return _this3._unmanageNode(node);
        });
      }
      /**
       * If a descendant node is found with an `inert` attribute, adopt its managed nodes.
       * @param {!HTMLElement} node
       */
    }, {
      key: "_adoptInertRoot",
      value: function _adoptInertRoot(node) {
        var inertSubroot = this._inertManager.getInertRoot(node);
        if (!inertSubroot) {
          this._inertManager.setInert(node, true);
          inertSubroot = this._inertManager.getInertRoot(node);
        }
        inertSubroot.managedNodes.forEach(function(savedInertNode) {
          this._manageNode(savedInertNode.node);
        }, this);
      }
      /**
       * Callback used when mutation observer detects subtree additions, removals, or attribute changes.
       * @param {!Array<!MutationRecord>} records
       * @param {!MutationObserver} self
       */
    }, {
      key: "_onMutation",
      value: function _onMutation(records, self) {
        records.forEach(function(record) {
          var target = (
            /** @type {!HTMLElement} */
            record.target
          );
          if (record.type === "childList") {
            slice.call(record.addedNodes).forEach(function(node) {
              this._makeSubtreeUnfocusable(node);
            }, this);
            slice.call(record.removedNodes).forEach(function(node) {
              this._unmanageSubtree(node);
            }, this);
          } else if (record.type === "attributes") {
            if (record.attributeName === "tabindex") {
              this._manageNode(target);
            } else if (target !== this._rootElement && record.attributeName === "inert" && target.hasAttribute("inert")) {
              this._adoptInertRoot(target);
              var inertSubroot = this._inertManager.getInertRoot(target);
              this._managedNodes.forEach(function(managedNode) {
                if (target.contains(managedNode.node)) {
                  inertSubroot._manageNode(managedNode.node);
                }
              });
            }
          }
        }, this);
      }
    }, {
      key: "managedNodes",
      get: function get() {
        return new Set(this._managedNodes);
      }
      /** @return {boolean} */
    }, {
      key: "hasSavedAriaHidden",
      get: function get() {
        return this._savedAriaHidden !== null;
      }
      /** @param {?string} ariaHidden */
    }, {
      key: "savedAriaHidden",
      set: function set(ariaHidden) {
        this._savedAriaHidden = ariaHidden;
      },
      get: function get() {
        return this._savedAriaHidden;
      }
    }]);
    return InertRoot2;
  }();
  var InertNode = function() {
    function InertNode2(node, inertRoot) {
      _classCallCheck(this, InertNode2);
      this._node = node;
      this._overrodeFocusMethod = false;
      this._inertRoots = /* @__PURE__ */ new Set([inertRoot]);
      this._savedTabIndex = null;
      this._destroyed = false;
      this.ensureUntabbable();
    }
    _createClass(InertNode2, [{
      key: "destructor",
      value: function destructor() {
        this._throwIfDestroyed();
        if (this._node && this._node.nodeType === Node.ELEMENT_NODE) {
          var element = (
            /** @type {!HTMLElement} */
            this._node
          );
          if (this._savedTabIndex !== null) {
            element.setAttribute("tabindex", this._savedTabIndex);
          } else {
            element.removeAttribute("tabindex");
          }
          if (this._overrodeFocusMethod) {
            delete element.focus;
          }
        }
        this._node = /** @type {?} */
        null;
        this._inertRoots = /** @type {?} */
        null;
        this._destroyed = true;
      }
      /**
       * @type {boolean} Whether this object is obsolete because the managed node is no longer inert.
       * If the object has been destroyed, any attempt to access it will cause an exception.
       */
    }, {
      key: "_throwIfDestroyed",
      /**
       * Throw if user tries to access destroyed InertNode.
       */
      value: function _throwIfDestroyed() {
        if (this.destroyed) {
          throw new Error("Trying to access destroyed InertNode");
        }
      }
      /** @return {boolean} */
    }, {
      key: "ensureUntabbable",
      /** Save the existing tabindex value and make the node untabbable and unfocusable */
      value: function ensureUntabbable() {
        if (this.node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }
        var element = (
          /** @type {!HTMLElement} */
          this.node
        );
        if (matches.call(element, _focusableElementsString)) {
          if (
            /** @type {!HTMLElement} */
            element.tabIndex === -1 && this.hasSavedTabIndex
          ) {
            return;
          }
          if (element.hasAttribute("tabindex")) {
            this._savedTabIndex = /** @type {!HTMLElement} */
            element.tabIndex;
          }
          element.setAttribute("tabindex", "-1");
          if (element.nodeType === Node.ELEMENT_NODE) {
            element.focus = function() {
            };
            this._overrodeFocusMethod = true;
          }
        } else if (element.hasAttribute("tabindex")) {
          this._savedTabIndex = /** @type {!HTMLElement} */
          element.tabIndex;
          element.removeAttribute("tabindex");
        }
      }
      /**
       * Add another inert root to this inert node's set of managing inert roots.
       * @param {!InertRoot} inertRoot
       */
    }, {
      key: "addInertRoot",
      value: function addInertRoot(inertRoot) {
        this._throwIfDestroyed();
        this._inertRoots.add(inertRoot);
      }
      /**
       * Remove the given inert root from this inert node's set of managing inert roots.
       * If the set of managing inert roots becomes empty, this node is no longer inert,
       * so the object should be destroyed.
       * @param {!InertRoot} inertRoot
       */
    }, {
      key: "removeInertRoot",
      value: function removeInertRoot(inertRoot) {
        this._throwIfDestroyed();
        this._inertRoots["delete"](inertRoot);
        if (this._inertRoots.size === 0) {
          this.destructor();
        }
      }
    }, {
      key: "destroyed",
      get: function get() {
        return (
          /** @type {!InertNode} */
          this._destroyed
        );
      }
    }, {
      key: "hasSavedTabIndex",
      get: function get() {
        return this._savedTabIndex !== null;
      }
      /** @return {!Node} */
    }, {
      key: "node",
      get: function get() {
        this._throwIfDestroyed();
        return this._node;
      }
      /** @param {?number} tabIndex */
    }, {
      key: "savedTabIndex",
      set: function set(tabIndex) {
        this._throwIfDestroyed();
        this._savedTabIndex = tabIndex;
      },
      get: function get() {
        this._throwIfDestroyed();
        return this._savedTabIndex;
      }
    }]);
    return InertNode2;
  }();
  var InertManager = function() {
    function InertManager2(document2) {
      _classCallCheck(this, InertManager2);
      if (!document2) {
        throw new Error("Missing required argument; InertManager needs to wrap a document.");
      }
      this._document = document2;
      this._managedNodes = /* @__PURE__ */ new Map();
      this._inertRoots = /* @__PURE__ */ new Map();
      this._observer = new MutationObserver(this._watchForInert.bind(this));
      addInertStyle(document2.head || document2.body || document2.documentElement);
      if (document2.readyState === "loading") {
        document2.addEventListener("DOMContentLoaded", this._onDocumentLoaded.bind(this));
      } else {
        this._onDocumentLoaded();
      }
    }
    _createClass(InertManager2, [{
      key: "setInert",
      value: function setInert(root, inert) {
        if (inert) {
          if (this._inertRoots.has(root)) {
            return;
          }
          var inertRoot = new InertRoot(root, this);
          root.setAttribute("inert", "");
          this._inertRoots.set(root, inertRoot);
          if (!this._document.body.contains(root)) {
            var parent = root.parentNode;
            while (parent) {
              if (parent.nodeType === 11) {
                addInertStyle(parent);
              }
              parent = parent.parentNode;
            }
          }
        } else {
          if (!this._inertRoots.has(root)) {
            return;
          }
          var _inertRoot = this._inertRoots.get(root);
          _inertRoot.destructor();
          this._inertRoots["delete"](root);
          root.removeAttribute("inert");
        }
      }
      /**
       * Get the InertRoot object corresponding to the given inert root element, if any.
       * @param {!Node} element
       * @return {!InertRoot|undefined}
       */
    }, {
      key: "getInertRoot",
      value: function getInertRoot(element) {
        return this._inertRoots.get(element);
      }
      /**
       * Register the given InertRoot as managing the given node.
       * In the case where the node has a previously existing inert root, this inert root will
       * be added to its set of inert roots.
       * @param {!Node} node
       * @param {!InertRoot} inertRoot
       * @return {!InertNode} inertNode
       */
    }, {
      key: "register",
      value: function register(node, inertRoot) {
        var inertNode = this._managedNodes.get(node);
        if (inertNode !== void 0) {
          inertNode.addInertRoot(inertRoot);
        } else {
          inertNode = new InertNode(node, inertRoot);
        }
        this._managedNodes.set(node, inertNode);
        return inertNode;
      }
      /**
       * De-register the given InertRoot as managing the given inert node.
       * Removes the inert root from the InertNode's set of managing inert roots, and remove the inert
       * node from the InertManager's set of managed nodes if it is destroyed.
       * If the node is not currently managed, this is essentially a no-op.
       * @param {!Node} node
       * @param {!InertRoot} inertRoot
       * @return {?InertNode} The potentially destroyed InertNode associated with this node, if any.
       */
    }, {
      key: "deregister",
      value: function deregister(node, inertRoot) {
        var inertNode = this._managedNodes.get(node);
        if (!inertNode) {
          return null;
        }
        inertNode.removeInertRoot(inertRoot);
        if (inertNode.destroyed) {
          this._managedNodes["delete"](node);
        }
        return inertNode;
      }
      /**
       * Callback used when document has finished loading.
       */
    }, {
      key: "_onDocumentLoaded",
      value: function _onDocumentLoaded() {
        var inertElements = slice.call(this._document.querySelectorAll("[inert]"));
        inertElements.forEach(function(inertElement) {
          this.setInert(inertElement, true);
        }, this);
        this._observer.observe(this._document.body || this._document.documentElement, { attributes: true, subtree: true, childList: true });
      }
      /**
       * Callback used when mutation observer detects attribute changes.
       * @param {!Array<!MutationRecord>} records
       * @param {!MutationObserver} self
       */
    }, {
      key: "_watchForInert",
      value: function _watchForInert(records, self) {
        var _this = this;
        records.forEach(function(record) {
          switch (record.type) {
            case "childList":
              slice.call(record.addedNodes).forEach(function(node) {
                if (node.nodeType !== Node.ELEMENT_NODE) {
                  return;
                }
                var inertElements = slice.call(node.querySelectorAll("[inert]"));
                if (matches.call(node, "[inert]")) {
                  inertElements.unshift(node);
                }
                inertElements.forEach(function(inertElement) {
                  this.setInert(inertElement, true);
                }, _this);
              }, _this);
              break;
            case "attributes":
              if (record.attributeName !== "inert") {
                return;
              }
              var target = (
                /** @type {!HTMLElement} */
                record.target
              );
              var inert = target.hasAttribute("inert");
              _this.setInert(target, inert);
              break;
          }
        }, this);
      }
    }]);
    return InertManager2;
  }();
  function composedTreeWalk(node, callback, shadowRootAncestor) {
    if (node.nodeType == Node.ELEMENT_NODE) {
      var element = (
        /** @type {!HTMLElement} */
        node
      );
      if (callback) {
        callback(element);
      }
      var shadowRoot = (
        /** @type {!HTMLElement} */
        element.shadowRoot
      );
      if (shadowRoot) {
        composedTreeWalk(shadowRoot, callback, shadowRoot);
        return;
      }
      if (element.localName == "content") {
        var content = (
          /** @type {!HTMLContentElement} */
          element
        );
        var distributedNodes = content.getDistributedNodes ? content.getDistributedNodes() : [];
        for (var i = 0; i < distributedNodes.length; i++) {
          composedTreeWalk(distributedNodes[i], callback, shadowRootAncestor);
        }
        return;
      }
      if (element.localName == "slot") {
        var slot = (
          /** @type {!HTMLSlotElement} */
          element
        );
        var _distributedNodes = slot.assignedNodes ? slot.assignedNodes({ flatten: true }) : [];
        for (var _i = 0; _i < _distributedNodes.length; _i++) {
          composedTreeWalk(_distributedNodes[_i], callback, shadowRootAncestor);
        }
        return;
      }
    }
    var child = node.firstChild;
    while (child != null) {
      composedTreeWalk(child, callback, shadowRootAncestor);
      child = child.nextSibling;
    }
  }
  function addInertStyle(node) {
    if (node.querySelector("style#inert-style, link#inert-style")) {
      return;
    }
    var style = document.createElement("style");
    style.setAttribute("id", "inert-style");
    style.textContent = "\n[inert] {\n  pointer-events: none;\n  cursor: default;\n}\n\n[inert], [inert] * {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n";
    node.appendChild(style);
  }
  if (!HTMLElement.prototype.hasOwnProperty("inert")) {
    var inertManager = new InertManager(document);
    Object.defineProperty(HTMLElement.prototype, "inert", {
      enumerable: true,
      /** @this {!HTMLElement} */
      get: function get() {
        return this.hasAttribute("inert");
      },
      /** @this {!HTMLElement} */
      set: function set(inert) {
        inertManager.setInert(this, inert);
      }
    });
  }
})();

// _src/js/global.js
import { Alpine as Alpine2, AlpinePlugins } from "vendor";
import { Splide as Splide2 } from "vendor";

// _src/js/alpine-plugins/fetched-fragment.js
function fetched_fragment_default(Alpine3) {
  Alpine3.magic("fetchedFragment", (el, { Alpine: Alpine4, evaluateLater }) => {
    return (url, selector, loadingClasses = null) => {
      let classNames;
      if (loadingClasses) {
        classNames = loadingClasses.split(/\s+/g);
        el.classList.add(...classNames);
      }
      return async () => {
        const html = await fetchHTMLFragment(url, selector);
        Alpine4.$data(el).$nextTick(() => {
          if (classNames) {
            el.classList.remove(...classNames);
          }
        });
        return html;
      };
    };
  });
}

// _src/js/alpine-plugins/html-if-set.js
function html_if_set_default(Alpine3) {
  Alpine3.directive(
    "html-if-set",
    (el, { modifiers, expression }, { effect, evaluateLater }) => {
      let evaluate = evaluateLater(expression);
      let useEmpty = modifiers.includes("use-empty");
      function saveInitialHTML() {
        el._x_custom_initialHTML = el.innerHTML;
      }
      function getInitialHTML() {
        return el._x_custom_initialHTML;
      }
      effect(() => {
        let newHTML;
        evaluate((value) => {
          if (Boolean(value)) {
            newHTML = value;
            if (!getInitialHTML()) {
              saveInitialHTML();
            }
          } else {
            if (useEmpty && value === "") {
              newHTML = value;
            } else {
              if (getInitialHTML()) {
                newHTML = getInitialHTML();
              }
            }
          }
          if (newHTML || useEmpty && newHTML === "") {
            Alpine3.mutateDom(() => {
              el.innerHTML = newHTML;
              el._x_ignoreSelf = true;
              Alpine3.initTree(el);
              delete el._x_ignoreSelf;
            });
          }
        });
      });
    }
  );
}

// _src/js/alpine-plugins/mask.js
function mask_default(Alpine3) {
  Alpine3.directive(
    "mask",
    (el, { value, expression }, { effect, evaluateLater }) => {
      let templateFn = () => expression;
      let lastInputValue = "";
      queueMicrotask(() => {
        if (["function", "dynamic"].includes(value)) {
          let evaluator = evaluateLater(expression);
          effect(() => {
            templateFn = (input) => {
              let result;
              Alpine3.dontAutoEvaluateFunctions(() => {
                evaluator(
                  (value2) => {
                    result = typeof value2 === "function" ? value2(input) : value2;
                  },
                  {
                    scope: {
                      // These are "magics" we'll make available to the x-mask:function:
                      $input: input,
                      $money: formatMoney.bind({ el })
                    }
                  }
                );
              });
              return result;
            };
            processInputValue(el, false);
          });
        } else {
          processInputValue(el, false);
        }
        if (el._x_model) el._x_model.set(el.value);
      });
      el.addEventListener("input", () => processInputValue(el));
      el.addEventListener("blur", () => processInputValue(el, false));
      el.addEventListener("remask", () => processInputValue(el, false, true));
      function processInputValue(el2, shouldRestoreCursor = true, ignoreBackspace = false) {
        let input = el2.value;
        let template = templateFn(input);
        if (!template || template === "false") return false;
        if (ignoreBackspace === false && lastInputValue.length - el2.value.length === 1) {
          return lastInputValue = el2.value;
        }
        let setInput = () => {
          lastInputValue = el2.value = formatInput(input, template);
        };
        if (shouldRestoreCursor) {
          restoreCursorPosition(el2, template, () => {
            setInput();
          });
        } else {
          setInput();
        }
      }
      function formatInput(input, template) {
        if (input === "") return "";
        let strippedDownInput = stripDown(template, input);
        let rebuiltInput = buildUp(template, strippedDownInput);
        return rebuiltInput;
      }
    }
  ).before("model");
}
function restoreCursorPosition(el, template, callback) {
  let cursorPosition = el.selectionStart;
  let unformattedValue = el.value;
  callback();
  let beforeLeftOfCursorBeforeFormatting = unformattedValue.slice(
    0,
    cursorPosition
  );
  let newPosition = buildUp(
    template,
    stripDown(template, beforeLeftOfCursorBeforeFormatting)
  ).length;
  el.setSelectionRange(newPosition, newPosition);
}
function stripDown(template, input) {
  let inputToBeStripped = input;
  let output = "";
  let regexes = {
    9: /[0-9]/,
    a: /[a-zA-Z]/,
    "*": /[a-zA-Z0-9]/
  };
  let wildcardTemplate = "";
  for (let i = 0; i < template.length; i++) {
    if (["9", "a", "*"].includes(template[i])) {
      wildcardTemplate += template[i];
      continue;
    }
    for (let j = 0; j < inputToBeStripped.length; j++) {
      if (inputToBeStripped[j] === template[i]) {
        inputToBeStripped = inputToBeStripped.slice(0, j) + inputToBeStripped.slice(j + 1);
        break;
      }
    }
  }
  for (let i = 0; i < wildcardTemplate.length; i++) {
    let found = false;
    for (let j = 0; j < inputToBeStripped.length; j++) {
      if (regexes[wildcardTemplate[i]].test(inputToBeStripped[j])) {
        output += inputToBeStripped[j];
        inputToBeStripped = inputToBeStripped.slice(0, j) + inputToBeStripped.slice(j + 1);
        found = true;
        break;
      }
    }
    if (!found) break;
  }
  return output;
}
function buildUp(template, input) {
  let clean = Array.from(input);
  let output = "";
  for (let i = 0; i < template.length; i++) {
    if (!["9", "a", "*"].includes(template[i])) {
      output += template[i];
      continue;
    }
    if (clean.length === 0) break;
    output += clean.shift();
  }
  return output;
}
function formatMoney(input, delimiter = ".", thousands, precision = 2) {
  if (input === "-") return "-";
  if (/^\D+$/.test(input)) return "9";
  if (thousands === null || thousands === void 0) {
    thousands = delimiter === "," ? "." : ",";
  }
  let addThousands = (input2, thousands2) => {
    let output = "";
    let counter = 0;
    for (let i = input2.length - 1; i >= 0; i--) {
      if (input2[i] === thousands2) continue;
      if (counter === 3) {
        output = input2[i] + thousands2 + output;
        counter = 0;
      } else {
        output = input2[i] + output;
      }
      counter++;
    }
    return output;
  };
  let minus = input.startsWith("-") ? "-" : "";
  let strippedInput = input.replaceAll(
    new RegExp(`[^0-9\\${delimiter}]`, "g"),
    ""
  );
  let template = Array.from({
    length: strippedInput.split(delimiter)[0].length
  }).fill("9").join("");
  template = `${minus}${addThousands(template, thousands)}`;
  if (precision > 0 && input.includes(delimiter))
    template += `${delimiter}` + "9".repeat(precision);
  queueMicrotask(() => {
    if (this.el.value.endsWith(delimiter)) return;
    if (this.el.value[this.el.selectionStart - 1] === delimiter) {
      this.el.setSelectionRange(
        this.el.selectionStart - 1,
        this.el.selectionStart - 1
      );
    }
  });
  return template;
}

// _src/js/stores/modals.js
var modals_default = {
  domContentLoaded: false,
  leftDrawer: { open: false, contents: "" },
  rightDrawer: { open: false, contents: "" },
  quickBuyDrawer: { open: false, contents: "" },
  modal: { open: false, contents: "" },
  promo: { open: false, contents: "" },
  popup: { open: false, contents: "" },
  modals: {},
  async init() {
    await switchOnDOMContentLoaded();
    await Alpine.nextTick();
    await Alpine.nextTick();
    for (const slotName of [
      "leftDrawer",
      "rightDrawer",
      "quickBuyDrawer",
      "modal",
      "promo",
      "popup"
    ]) {
      this.setUpShow(slotName);
      this.setUpHide(slotName);
    }
  },
  register(name, slotName) {
    this.modals[name] = slotName;
  },
  open(name) {
    if (this.modals[name]) {
      const slotName = this.modals[name];
      if (this[slotName].contents === name && this[slotName].open === true)
        return;
      document.body.dispatchEvent(
        new CustomEvent(`${kebabCase(name)}-will-open`, { bubbles: true })
      );
      document.body.dispatchEvent(
        new CustomEvent(`${kebabCase(slotName)}-will-open`, { bubbles: true })
      );
      this[slotName].contents = name;
      this[slotName].open = true;
    }
  },
  close(nameOrSlotName) {
    let name, slotName;
    if (this.modals[nameOrSlotName]) {
      name = nameOrSlotName;
      slotName = this.modals[nameOrSlotName];
    } else {
      name = this[nameOrSlotName].contents;
      slotName = nameOrSlotName;
    }
    if (this[slotName].contents !== name || this[slotName].open !== true)
      return;
    document.body.dispatchEvent(
      new CustomEvent(`${kebabCase(name)}-will-close`, {
        bubbles: true
      })
    );
    document.body.dispatchEvent(
      new CustomEvent(`${kebabCase(slotName)}-will-close`, { bubbles: true })
    );
    this[slotName].open = false;
  },
  setUpShow(slotName) {
    const slotEl = document.getElementById(`${kebabCase(slotName)}-slot`);
    slotEl._x_doShow = async () => {
      const dispatchOpenEvents = () => {
        const name = Alpine.store("modals")[slotName].contents;
        document.body.dispatchEvent(
          new CustomEvent(`${kebabCase(name)}-is-open`, {
            bubbles: true
          })
        );
        document.body.dispatchEvent(
          new CustomEvent(`${kebabCase(slotName)}-is-open`, {
            bubbles: true
          })
        );
      };
      Alpine.mutateDom(() => {
        if (slotEl.style.length === 1 && slotEl.style.display === "none") {
          slotEl.removeAttribute("style");
        } else {
          slotEl.style.removeProperty("display");
        }
      });
      await Alpine.nextTick();
      try {
        const transitionEl = slotEl.hasAttribute("x-show") ? slotEl : slotEl.closest("[x-show]");
        await Promise.all(
          transitionEl.getAnimations().map((animation) => animation.finished)
        );
        dispatchOpenEvents();
      } catch (e) {
        dispatchOpenEvents();
      }
    };
  },
  setUpHide(slotName) {
    const slotEl = document.getElementById(`${kebabCase(slotName)}-slot`);
    slotEl._x_doHide = () => {
      Alpine.mutateDom(() => {
        slotEl.style.setProperty("display", "none");
      });
      const name = Alpine.store("modals")[slotName].contents;
      Alpine.store("modals")[slotName].contents = "";
      document.body.dispatchEvent(
        new CustomEvent(`${kebabCase(name)}-is-closed`, {
          bubbles: true
        })
      );
      document.body.dispatchEvent(
        new CustomEvent(`${kebabCase(slotName)}-is-closed`, {
          bubbles: true
        })
      );
    };
  },
  closeAll() {
    Object.keys(this.modals).forEach((modal) => {
      Alpine.store("modals").close(modal);
    });
  },
  getSlotEl(slotName) {
    return document.getElementById(`${kebabCase(slotName)}-slot`) || null;
  },
  removeExistingContents(slotName, selector) {
    const existingModalContents = this.getSlotEl(slotName)?.querySelector(selector);
    if (existingModalContents) existingModalContents.remove();
  }
};

// _src/js/stores/cart-count.js
var cart_count_default = {
  count: window.theme && window.theme.cartItemCount || 0,
  init() {
    window.addEventListener("baseline:cart:afteradditem", (e) => {
      this._setFromFetchedSection(e.detail.response);
    });
    window.addEventListener("baseline:cart:cartqtychange", (e) => {
      this._setFromFetchedSection(e.detail.response);
    });
    window.addEventListener("baseline:cart:update", (e) => {
      this._setFromFetchedSection(e.detail.response);
    });
  },
  _setFromFetchedSection(data) {
    const countSectionHTML = data.sections["cart-item-count"];
    this.count = parseInt(
      parseDOMFromString(countSectionHTML).firstElementChild.innerText.trim(),
      10
    );
    window.theme.cartItemCount = this.count;
  },
  countWithText() {
    let string = theme.strings.itemCountOther;
    if (this.count === 1) {
      string = theme.strings.itemCountOne;
    }
    return string.replace("{{ count }}", this.count);
  }
};

// _src/js/stores/favorites.js
var favorites_default = {
  items: [],
  storageKey: 'pr-favorites-v2',
  colourChoicesByHandle: {},
  productImagesByHandle: {},

  get count() {
    return this.items.length;
  },

  normalizeItem(item) {
    if (!item || typeof item !== 'object' || !item.id) {
      return null;
    }

    // Migrate legacy single artwork to artworks array
    var artworks = Array.isArray(item.artworks) ? item.artworks : [];
    if (artworks.length === 0 && item.artwork && item.artworkFileName) {
      // Legacy item with base64 artwork — we don't carry base64 into the new model
      // User will need to re-upload. Clear legacy fields.
    }

    return {
      ...item,
      key: String(item.id) + ':' + (item.variantId == null ? 'any' : String(item.variantId)),
      variantId: item.variantId == null ? null : Number(item.variantId),
      colour: typeof item.colour === 'string' && item.colour ? item.colour : null,
      hasColours: item.hasColours === true,
      sizeOptions: Array.isArray(item.sizeOptions) ? item.sizeOptions : [],
      sizeSplit: item.sizeSplit && typeof item.sizeSplit === 'object' ? item.sizeSplit : null,
      vendor: typeof item.vendor === 'string' ? item.vendor : '',
      productImage: typeof item.productImage === 'string' && item.productImage
        ? item.productImage
        : (item.variantId == null && typeof item.image === 'string' ? item.image : ''),
      color: undefined,
      moq: parseInt(item.moq, 10) || 24,
      quantity: Math.max(1, parseInt(item.quantity, 10) || parseInt(item.moq, 10) || 24),
      artworks: artworks,
      artwork: null,
      artworkFileName: null,
      artworkLink: typeof item.artworkLink === 'string' ? item.artworkLink : '',
      notes: typeof item.notes === 'string' ? item.notes : ''
    };
  },

  init() {
    this.loadFromStorage();
  },

  loadFromStorage() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        const parsed = JSON.parse(stored);
        this.items = Array.isArray(parsed) ? parsed.map(item => this.normalizeItem(item)).filter(Boolean) : [];
        this.saveToStorage();
      } else {
        this.items = [];
      }
    } catch (e) {
      console.error('Error loading favorites from storage:', e);
      this.items = [];
    }
  },

  saveToStorage() {
    try {
      // Strip non-serializable _file references from artworks before saving
      var serializable = this.items.map(function(item) {
        if (!item.artworks || item.artworks.length === 0) return item;
        return {
          ...item,
          artworks: item.artworks.map(function(aw) {
            var copy = { ...aw };
            delete copy._file;
            return copy;
          })
        };
      });
      localStorage.setItem(this.storageKey, JSON.stringify(serializable));
    } catch (e) {
      console.error('Error saving favorites to storage:', e);
    }
  },

  has(productId) {
    return this.items.some(item => item.id === productId);
  },

  hasLine(key) {
    return this.items.some(item => item.key === key);
  },

  add(product) {
    const normalizedProduct = this.normalizeItem(product);
    if (!normalizedProduct || this.hasLine(normalizedProduct.key)) {
      return false;
    }

    this.items = [...this.items, normalizedProduct];
    this.saveToStorage();
    document.dispatchEvent(new CustomEvent('quote-item-added', {
      detail: {
        product: normalizedProduct,
        count: this.count
      }
    }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quote_item_added',
      product_id: normalizedProduct.id,
      variant_id: normalizedProduct.variantId,
      colour: normalizedProduct.colour,
      product_title: normalizedProduct.title,
      quote_count: this.count,
      page_path: window.location.pathname
    });
    return true;
  },

  remove(key) {
    const removed = this.items.find(item => item.key === key);
    this.items = this.items.filter(item => item.key !== key);
    this.saveToStorage();
    if (removed) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'quote_item_removed',
        product_id: removed.id,
        variant_id: removed.variantId,
        colour: removed.colour,
        product_title: removed.title,
        quote_count: this.count,
        page_path: window.location.pathname
      });
    }
  },

  toggle(product) {
    const item = this.normalizeItem(product);
    if (!item) return;
    if (this.hasLine(item.key)) {
      this.remove(item.key);
    } else {
      this.add(item);
    }
  },

  rekey(key, choice) {
    const item = this.items.find(row => row.key === key);
    if (!item) return false;
    const target = String(item.id) + ':' + (choice.variantId == null ? 'any' : String(choice.variantId));
    if (target !== key && this.hasLine(target)) return false;
    item.key = target;
    item.variantId = choice.variantId == null ? null : Number(choice.variantId);
    item.colour = choice.colour || choice.label || null;
    if (typeof choice.image === 'string' && choice.image) {
      item.image = choice.image;
    } else if (item.variantId == null) {
      if (item.productImage) {
        item.image = item.productImage;
      } else if (Object.prototype.hasOwnProperty.call(this.productImagesByHandle, item.handle)) {
        item.image = this.productImagesByHandle[item.handle] || '';
      }
    }
    this.items = [...this.items];
    this.saveToStorage();
    return true;
  },

  setSizeSplit(key, split) {
    const item = this.items.find(row => row.key === key);
    if (!item) return false;
    const valid = split && typeof split === 'object'
      ? Object.fromEntries(Object.entries(split).filter(([size, qty]) =>
        item.sizeOptions.includes(size) && Number.isInteger(qty) && qty >= 1)) : null;
    item.sizeSplit = split === null ? null : valid;
    if (item.sizeSplit && Object.keys(item.sizeSplit).length) {
      item.quantity = Object.values(item.sizeSplit).reduce((sum, qty) => sum + qty, 0);
    }
    this.items = [...this.items];
    this.saveToStorage();
    return true;
  },

  moqShortfalls() {
    const totals = new Map();
    for (const item of this.items) {
      const previous = totals.get(item.id) || { id: item.id, title: item.title, total: 0, moq: item.moq || 24 };
      previous.total += Math.max(1, parseInt(item.quantity, 10) || 1);
      totals.set(item.id, previous);
    }
    return [...totals.values()].filter(row => row.total < row.moq);
  },

  async loadColourChoices(key) {
    const item = this.items.find(row => row.key === key);
    if (!item || !item.hasColours || !item.handle) return [];
    if (this.colourChoicesByHandle[item.handle]) {
      this.hydrateProductImage(item, this.productImagesByHandle[item.handle]);
      return this.colourChoicesByHandle[item.handle];
    }
    try {
      const response = await fetch('/products/' + encodeURIComponent(item.handle) + '.js');
      if (!response.ok) throw new Error('Colour options unavailable');
      const product = await response.json();
      const position = (product.options || []).findIndex(option =>
        /^(color|colour)$/i.test(typeof option === 'string' ? option : option.name));
      if (position < 0) throw new Error('Colour option absent');
      const grouped = new Map();
      const productImage = product.featured_image && (product.featured_image.src || product.featured_image);
      this.productImagesByHandle = {
        ...this.productImagesByHandle,
        [item.handle]: typeof productImage === 'string' ? productImage : ''
      };
      this.hydrateProductImage(item, productImage);
      for (const variant of product.variants || []) {
        const label = variant['option' + (position + 1)];
        if (!label || !variant.id) continue;
        const variantImage = variant.featured_image && (variant.featured_image.src || variant.featured_image);
        const list = grouped.get(label) || [];
        list.push({
          label,
          variantId: Number(variant.id),
          image: variantImage || productImage || item.productImage || item.image || ''
        });
        grouped.set(label, list);
      }
      const choices = [...grouped.values()].filter(list => list.length === 1).map(list => list[0]);
      this.colourChoicesByHandle = { ...this.colourChoicesByHandle, [item.handle]: choices };
      if (item.variantId && !choices.some(choice => choice.variantId === item.variantId)) {
        const byLabel = choices.filter(choice => choice.label === item.colour);
        this.rekey(key, byLabel.length === 1 ? byLabel[0] : { variantId: null, colour: null });
      }
      return choices;
    } catch (_) {
      this.colourChoicesByHandle = { ...this.colourChoicesByHandle, [item.handle]: [] };
      return [];
    }
  },

  colourChoiceTaken(item, choice) {
    const target = String(item.id) + ':' + (choice.variantId == null ? 'any' : String(choice.variantId));
    return target !== item.key && this.hasLine(target);
  },

  hydrateProductImage(item, productImage) {
    if (!item || typeof productImage !== 'string' || !productImage || item.productImage === productImage) return;
    item.productImage = productImage;
    this.items = [...this.items];
    this.saveToStorage();
  },

  canSelectTbc(item) {
    if (!item || this.colourChoiceTaken(item, { variantId: null })) return false;
    return item.variantId == null
      || Boolean(item.productImage)
      || Object.prototype.hasOwnProperty.call(this.productImagesByHandle, item.handle);
  },

  clear() {
    this.items = [];
    this.saveToStorage();
  },

  updateItemMeta(key, field, value) {
    const item = this.items.find(i => i.key === key);
    if (!item) {
      return this.getItemMeta(key);
    }

    if (field === 'quantity') {
      item.quantity = Math.max(1, parseInt(value, 10) || 1);
      item.sizeSplit = null;
    } else if (field === 'notes') {
      item.notes = typeof value === 'string' ? value : '';
    } else if (field === 'artworks') {
      item.artworks = Array.isArray(value) ? value : [];
    } else if (field === 'artworkLink') {
      item.artworkLink = typeof value === 'string' ? value : '';
    } else {
      item[field] = value;
    }

    this.items = [...this.items];
    this.saveToStorage();
    if (field !== 'artworks') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'quote_item_meta_updated',
        product_id: item.id,
        variant_id: item.variantId,
        colour: item.colour,
        field: field,
        page_path: window.location.pathname
      });
    }
    return this.getItemMeta(key);
  },

  getItemMeta(key) {
    const item = this.items.find(i => i.key === key);
    return {
      quantity: item?.quantity || 1,
      artworks: item?.artworks || [],
      notes: item?.notes || '',
      sizeSplit: item?.sizeSplit || null,
    };
  },

  countWithText() {
    const count = this.count;
    if (count === 1) {
      return '1 item';
    }
    return `${count} items`;
  },

  getProductData() {
    return this.items.map(item => {
      var doneFiles = (item.artworks || []).filter(function(a) { return a.status === 'done' && a.storagePath; });
      return {
        id: item.id,
        handle: item.handle,
        title: item.title,
        price: item.price,
        url: item.url,
        quantity: item.quantity || item.moq || 24,
        variantId: item.variantId,
        colour: item.colour || (item.hasColours ? 'TBC' : null),
        sizeSplit: item.sizeSplit && Object.keys(item.sizeSplit).length
          ? Object.entries(item.sizeSplit).map(([size, qty]) => ({ size, qty })) : null,
        sizesTbc: item.sizeOptions.length > 0 && (!item.sizeSplit || !Object.keys(item.sizeSplit).length),
        artworkFiles: doneFiles.map(function(a) { return { storagePath: a.storagePath, fileName: a.fileName, placement: a.placement || '' }; }),
        artworkLink: item.artworkLink || null,
        notes: item.notes || ''
      };
    });
  }
};

// _src/js/components/favorites-drawer.js
var favorites_drawer_default = () => ({
  init() {
    Alpine.store('modals').register('favorites', 'rightDrawer');

    // Toggle body class for external widget styling (e.g., chat widgets in iframes)
    document.addEventListener('favorites-will-open', () => {
      document.body.classList.add('favorites-drawer-open');
    });
    document.addEventListener('favorites-will-close', () => {
      document.body.classList.remove('favorites-drawer-open');
    });
  },

  formatMoney(cents) {
    if (window.theme && window.theme.Shopify && window.theme.Shopify.formatMoney) {
      return window.theme.Shopify.formatMoney(cents);
    }
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: window.theme?.currency || 'USD' });
  }
});

// _src/js/stores/chat-quote.js
var chat_quote_default = {
  items: [],
  summary: '',
  company: '',
  timeline: '',
  location: '',
  estimatedBudget: null,
  sessionId: null,
  active: false,

  get count() {
    return this.items.length;
  },

  get hasData() {
    return this.items.length > 0 || this.summary.length > 0;
  },

  setFromChatData(quoteData, sessionId) {
    this.items = (quoteData.items || []).map(function(item) {
      return {
        id: item.id || ('custom-' + Date.now() + '-' + Math.random().toString(36).substr(2, 5)),
        title: item.title || 'Custom Item',
        description: item.description || '',
        quantity: item.quantity || null,
        sizes: item.sizes || [],
        colors: item.colors || [],
        decorationMethod: item.decorationMethod || '',
        isCustom: item.isCustom !== false,
        catalogProductId: item.catalogProductId || null,
        catalogProductHandle: item.catalogProductHandle || null,
        image: item.image || null
      };
    });
    this.summary = quoteData.summary || '';
    this.company = quoteData.company || '';
    this.timeline = quoteData.timeline || '';
    this.location = quoteData.location || '';
    this.estimatedBudget = quoteData.estimatedBudget || null;
    this.sessionId = sessionId || null;
    this.active = true;
  },

  clear() {
    this.items = [];
    this.summary = '';
    this.company = '';
    this.timeline = '';
    this.location = '';
    this.estimatedBudget = null;
    this.sessionId = null;
    this.active = false;
  },

  getProductData() {
    return this.items.map(function(item) {
      return {
        id: item.catalogProductId || item.id,
        handle: item.catalogProductHandle || null,
        title: item.title,
        isCustom: item.isCustom,
        description: item.description,
        quantity: item.quantity,
        sizes: item.sizes,
        colors: item.colors,
        decorationMethod: item.decorationMethod
      };
    });
  }
};

// _src/js/lib/turnstile.js
// Cloudflare Turnstile, execute-mode. Shared by BookRequestForm and QuoteRequestForm.
//
// Three properties drive this design:
//
//  1. LAZY. The script loads on first form interaction, never on page load — the
//     quote modal renders on every page of the store (layout/theme.liquid:205), so
//     an eager load would tax the whole site for a widget most visitors never use.
//
//  2. FRESH TOKEN PER SUBMIT. Turnstile tokens expire after 300s and are single-use.
//     Both forms routinely sit open longer than that. Rendering on load and fighting
//     expiry would let a slow, genuine customer submit a stale token and be rejected.
//     execution:'execute' + calling execute() inside the submit handler removes the
//     expiry window entirely.
//
//  3. VISIBLE WHEN CHALLENGED. appearance:'interaction-only' shows the widget
//     precisely when the visitor has to click it. Rendering into a hidden container
//     silently breaks that case — the challenge is laid out at 0x0, nobody can solve
//     it, and the customer is 403'd on an empty token. Two genuine quote requests
//     were lost that way on 2026-09-07. The widget therefore lives in an overlay that
//     is revealed on before-interactive-callback and hidden again afterwards.
//
// NOTHING HERE MAY BLOCK A SUBMIT. Script blocked, render throws, challenge errors,
// Cloudflare slow — every path resolves to '' and lets the server decide. A client
// that withholds a lead is precisely the failure the honeypot produced. But '' alone
// is not something a server can rule on fairly: a blocked customer and a bot that
// sent nothing look identical. Every failure therefore records WHY, and the forms
// post it alongside the empty token.
var TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
// Waiting on Cloudflare, with no human in the loop.
var TURNSTILE_TIMEOUT_MS = 15000;
// Waiting on a person to notice the challenge and click it. 15s is a network budget,
// not an attention span; keeping it here is what made every retry fail.
var TURNSTILE_INTERACTIVE_TIMEOUT_MS = 120000;
var turnstileState = { scriptPromise: null, widgets: {}, lastFailure: {} };

// Resolves true/false — never rejects. Cached, so concurrent callers share one load.
function loadTurnstileScript() {
  if (turnstileState.scriptPromise) return turnstileState.scriptPromise;
  turnstileState.scriptPromise = new Promise(function (resolve) {
    try {
      if (window.turnstile) return resolve(true);
      var script = document.createElement('script');
      script.src = TURNSTILE_SCRIPT_URL;
      script.async = true;
      script.defer = true;
      script.onload = function () { resolve(true); };
      script.onerror = function () { resolve(false); };
      document.head.appendChild(script);
    } catch (_) {
      resolve(false);
    }
  });
  return turnstileState.scriptPromise;
}

// Call on first interaction so the script is warm by the time the customer submits.
function preloadTurnstile(siteKey) {
  if (!siteKey) return;
  loadTurnstileScript();
}

// Records why a token could not be minted and yields the empty token in one step, so
// no failure path can return '' without also saying what happened.
function recordTurnstileFailure(action, reason) {
  turnstileState.lastFailure[action] = reason;
  return '';
}

// The reason behind the most recent empty token for this action, '' after a success.
function getTurnstileFailure(action) {
  return turnstileState.lastFailure[action] || '';
}

// Hosts the widget for the one case where the visitor must see it. Fixed and above the
// quote modal (z-110, snippets/modal.liquid) — a plain div on document.body would be
// painted underneath it. `inert` is cleared on reveal because the modal's x-trap.inert
// marks nodes outside itself unclickable; a widget built during an earlier submit can
// outlive the trap that was active when it was made.
function buildTurnstileOverlay() {
  var overlay = document.createElement('div');
  overlay.setAttribute('data-turnstile-overlay', '');
  overlay.style.display = 'none';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.right = '0';
  overlay.style.bottom = '0';
  overlay.style.zIndex = '2147483000';
  overlay.style.alignItems = 'center';
  overlay.style.justifyContent = 'center';
  overlay.style.background = 'rgba(0, 0, 0, 0.45)';

  var card = document.createElement('div');
  card.style.background = '#FBFBF6';
  card.style.border = '2px solid black';
  card.style.borderRadius = '27px';
  card.style.boxShadow = '0 4px 13px 2px rgba(0, 0, 0, 0.1)';
  card.style.padding = '28px 32px';
  card.style.maxWidth = '90vw';
  card.style.textAlign = 'center';

  var label = document.createElement('div');
  label.textContent = 'One quick check before we send your request.';
  label.style.color = 'black';
  label.style.fontSize = '15px';
  label.style.marginBottom = '16px';

  var host = document.createElement('div');
  host.style.display = 'flex';
  host.style.justifyContent = 'center';

  card.appendChild(label);
  card.appendChild(host);
  overlay.appendChild(card);
  document.body.appendChild(overlay);
  return { overlay: overlay, host: host };
}

function revealTurnstile(entry) {
  try {
    if (!entry || !entry.overlay) return;
    if (entry.overlay.removeAttribute) entry.overlay.removeAttribute('inert');
    entry.overlay.style.display = 'flex';
  } catch (_) {
    // Revealing is best effort. Failing to show the challenge must not also throw
    // out of Cloudflare's callback and strand the submit.
  }
}

function hideTurnstile(entry) {
  try {
    if (entry && entry.overlay) entry.overlay.style.display = 'none';
  } catch (_) { /* see revealTurnstile */ }
}

// A widget that has failed does not recover: reset() + execute() re-enters the same
// dead state, which is why one rejected customer stayed rejected on every retry.
// Tear it down so the next submit builds a fresh one.
function destroyTurnstileWidget(action) {
  var entry = turnstileState.widgets[action];
  if (!entry) return;
  delete turnstileState.widgets[action];
  // Deferred: this runs from inside Cloudflare's own callback, and removing the
  // widget out from under it is not something the API promises to survive.
  setTimeout(function () {
    try {
      if (entry.id && window.turnstile && window.turnstile.remove) window.turnstile.remove(entry.id);
    } catch (_) { /* already detached */ }
    try {
      if (entry.overlay && entry.overlay.parentNode) entry.overlay.parentNode.removeChild(entry.overlay);
    } catch (_) { /* already detached */ }
  }, 0);
}

function createTurnstileWidget(siteKey, action) {
  try {
    var parts = buildTurnstileOverlay();
    var entry = { id: null, finish: null, extend: null, overlay: parts.overlay };
    entry.id = window.turnstile.render(parts.host, {
      sitekey: siteKey,
      // The server requires this to match the endpoint it arrived at. Our site key
      // is public, so without it a token farmed on one form works on the other.
      action: action,
      execution: 'execute',
      appearance: 'interaction-only',
      callback: function (token) { if (entry.finish) entry.finish(token, ''); },
      'error-callback': function () { if (entry.finish) entry.finish('', 'render-error'); },
      'timeout-callback': function () { if (entry.finish) entry.finish('', 'challenge-timeout'); },
      'expired-callback': function () { if (entry.finish) entry.finish('', 'token-expired'); },
      // The whole point of interaction-only: Cloudflare has decided this visitor must
      // click something, so it has to be on screen and the clock has to slow down.
      'before-interactive-callback': function () {
        revealTurnstile(entry);
        if (entry.extend) entry.extend();
      },
      'after-interactive-callback': function () { hideTurnstile(entry); }
    });
    turnstileState.widgets[action] = entry;
    return entry;
  } catch (_) {
    return null;
  }
}

// Always resolves to a string. '' means "no token" — the server rules on it, using
// getTurnstileFailure(action) to know which kind of nothing it is looking at.
async function getTurnstileToken(siteKey, action) {
  turnstileState.lastFailure[action] = '';
  if (!siteKey) return recordTurnstileFailure(action, 'no-site-key');
  try {
    var loaded = await loadTurnstileScript();
    if (!loaded || !window.turnstile) return recordTurnstileFailure(action, 'script-blocked');

    var entry = turnstileState.widgets[action];
    if (entry) {
      // Tokens are single-use; a widget must be reset before it can mint another.
      window.turnstile.reset(entry.id);
    } else {
      entry = createTurnstileWidget(siteKey, action);
      if (!entry) return recordTurnstileFailure(action, 'render-error');
    }

    return await new Promise(function (resolve) {
      var settled = false;
      var timer = null;
      var arm = function (ms, reason) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () { finish('', reason); }, ms);
      };
      var finish = function (token, reason) {
        if (settled) return;
        settled = true;
        entry.finish = null;
        entry.extend = null;
        if (timer) clearTimeout(timer);
        hideTurnstile(entry);
        var value = typeof token === 'string' ? token : '';
        if (!value) {
          destroyTurnstileWidget(action);
          recordTurnstileFailure(action, reason || 'unknown');
        }
        resolve(value);
      };
      entry.finish = finish;
      // Armed by before-interactive-callback once a person is in the loop.
      entry.extend = function () {
        if (!settled) arm(TURNSTILE_INTERACTIVE_TIMEOUT_MS, 'interaction-timeout');
      };
      // Belt and braces: if Cloudflare never calls back at all, submit unverified
      // rather than leaving the customer staring at a spinner.
      arm(TURNSTILE_TIMEOUT_MS, 'challenge-timeout');
      try {
        window.turnstile.execute(entry.id);
      } catch (_) {
        finish('', 'execute-error');
      }
    });
  } catch (_) {
    return recordTurnstileFailure(action, 'unexpected-error');
  }
}

// Other storefront bundles (currently the two Leavers builders) use this same
// fail-open client instead of shipping their own Turnstile implementation.
window.PrintRoomTurnstile = Object.freeze({
  preload: preloadTurnstile,
  getToken: getTurnstileToken,
  lastFailure: getTurnstileFailure
});

// _src/js/components/quote-request-form.js
var quote_request_form_default = () => ({
  formData: {
    name: '',
    email: '',
    phone: '',
    company: '',
    description: '',
    budget: 500,
    inHandDate: '',
    location: '',
    heardAbout: '',
    heardAboutDetail: ''
  },
  uploadedFile: null,
  uploadedFileName: '',
  submitting: false,
  successMessage: '',
  errorMessage: '',
  webhookUrl: '',
  uploadApiUrl: '',
  quoteSessionId: '',
  turnstileSiteKey: '',

  init() {
    Alpine.store('modals').register('quoteRequest', 'modal');
    // Get webhook URL from data attributes
    const container = this.$root;
    this.webhookUrl = container.dataset.webhookUrl || 'https://print-room-chatbot-api.vercel.app/api/quote-request';
    // Derive upload endpoint from webhook URL base
    var baseUrl = this.webhookUrl.replace(/\/api\/quote-request\/?$/, '');
    this.uploadApiUrl = baseUrl + '/api/quote-artwork-upload';
    this.turnstileSiteKey = container.dataset.turnstileSiteKey || '';

    // Listen for modal open to pre-populate from chat data and generate session ID
    document.body.addEventListener('quote-request-will-open', () => {
      // Warm the Turnstile script on first open. This modal renders on EVERY page
      // (layout/theme.liquid:205), so it must never load on page load.
      preloadTurnstile(this.turnstileSiteKey);
      // Generate a unique session ID for grouping artwork uploads
      if (!this.quoteSessionId) {
        this.quoteSessionId = crypto.randomUUID ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).substr(2));
      }
      this.prefillFromChatQuote();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'quote_request_started',
        quote_count: Alpine.store('favorites').count,
        page_path: window.location.pathname
      });
    });

    // formData.heardAbout has two write paths: the visible panel buttons (via
    // selectHeardAbout) and the native <select> (via x-model), which bypasses
    // selectHeardAbout entirely. A handler alone can't cover both, so the
    // clearing rule is attached to the state change itself via $watch. Safe to
    // run alongside selectHeardAbout's own clearing — the operation is
    // idempotent.
    this.$watch('formData.heardAbout', (value) => {
      if (value !== 'Referral or word of mouth' && value !== 'Other') {
        this.formData.heardAboutDetail = '';
      }
    });
  },

  // Pre-populate form fields from chatQuote store data
  prefillFromChatQuote() {
    const chatQuote = Alpine.store('chatQuote');
    if (!chatQuote || !chatQuote.active) return;

    // Pre-fill description with conversation summary
    if (chatQuote.summary && !this.formData.description) {
      this.formData.description = chatQuote.summary;
    }

    // Pre-fill company if available
    if (chatQuote.company && !this.formData.company) {
      this.formData.company = chatQuote.company;
    }

    // Pre-fill in-hand date if timeline looks like a date
    if (chatQuote.timeline && !this.formData.inHandDate) {
      var parsed = new Date(chatQuote.timeline);
      if (!isNaN(parsed.getTime())) {
        this.formData.inHandDate = parsed.toISOString().split('T')[0];
      }
    }

    // Pre-fill location (map to valid select options)
    if (chatQuote.location && !this.formData.location) {
      var locationMap = {
        'new zealand': 'New Zealand',
        'nz': 'New Zealand',
        'australia': 'Australia',
        'au': 'Australia',
        'international': 'International'
      };
      var mapped = locationMap[chatQuote.location.toLowerCase()];
      if (mapped) this.formData.location = mapped;
    }

    // Pre-fill budget if available
    if (chatQuote.estimatedBudget) {
      var budget = Number(chatQuote.estimatedBudget);
      if (budget >= 500 && budget <= 10000) {
        this.formData.budget = Math.round(budget / 500) * 500;
      }
    }
  },

  handleFileUpload(event) {
    const file = event.target.files[0];
    if (file) {
      // Check file size (10MB max)
      if (file.size > 10 * 1024 * 1024) {
        this.uploadedFile = null;
        this.uploadedFileName = '';
        this.errorMessage = 'File size must be under 10MB';
        event.target.value = '';
        return;
      }
      this.uploadedFile = file;
      this.uploadedFileName = file.name;
      this.errorMessage = '';
    }
  },

  async handlePerProductFileUpload(event, productId) {
    const files = Array.from(event.target.files || []);
    if (files.length === 0) return;

    const favorites = Alpine.store('favorites');
    const item = favorites.items.find(function(i) { return i.key === productId; });
    if (!item) return;

    var currentArtworks = item.artworks || [];
    var remaining = 5 - currentArtworks.length;
    var filesToProcess = files.slice(0, remaining);

    if (files.length > remaining) {
      this.errorMessage = 'Maximum 5 files per product. Only the first ' + remaining + ' were added.';
    } else {
      this.errorMessage = '';
    }

    for (var i = 0; i < filesToProcess.length; i++) {
      var file = filesToProcess[i];
      if (file.size > 10 * 1024 * 1024) {
        this.errorMessage = file.name + ' exceeds 10MB limit.';
        continue;
      }
      var artworkEntry = {
        fileName: file.name,
        fileSize: file.size,
        mimeType: file.type || 'application/octet-stream',
        storagePath: null,
        status: 'uploading',
        placement: '',
        _file: file  // Transient — not persisted to localStorage
      };
      currentArtworks = [...currentArtworks, artworkEntry];
      favorites.updateItemMeta(productId, 'artworks', currentArtworks);

      // Upload in background (don't await — uploads run concurrently)
      this._uploadSingleFile(productId, currentArtworks.length - 1, file);
    }

    event.target.value = '';
  },

  async _uploadSingleFile(productId, artworkIndex, file) {
    var favorites = Alpine.store('favorites');
    var item = favorites.items.find(function(i) { return i.key === productId; });
    if (!item) return;

    try {
      // 1. Get signed upload URL from our API
      var signedRes = await fetch(this.uploadApiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fileName: file.name,
          mimeType: file.type || 'application/octet-stream',
          quoteSessionId: this.quoteSessionId,
          productHandle: item.handle || null,
          fileSize: file.size
        })
      });

      if (!signedRes.ok) {
        var errData = await signedRes.json().catch(function() { return {}; });
        throw new Error(errData.error || 'Failed to get upload URL');
      }

      var signed = await signedRes.json();

      // 2. Upload file directly to Supabase Storage using signed URL
      var uploadRes = await fetch(signed.signedUrl, {
        method: 'PUT',
        headers: { 'Content-Type': file.type || 'application/octet-stream' },
        body: file
      });

      if (!uploadRes.ok) {
        throw new Error('Storage upload failed: ' + uploadRes.status);
      }

      // 3. Mark as done
      var artworks = [...(item.artworks || [])];
      if (artworks[artworkIndex]) {
        artworks[artworkIndex] = {
          ...artworks[artworkIndex],
          storagePath: signed.storagePath,
          status: 'done',
          _file: null
        };
        favorites.updateItemMeta(productId, 'artworks', artworks);
      }
    } catch (err) {
      console.error('Artwork upload failed:', err);
      var artworks2 = [...(item.artworks || [])];
      if (artworks2[artworkIndex]) {
        artworks2[artworkIndex] = {
          ...artworks2[artworkIndex],
          status: 'error',
          _file: file  // Keep file reference for retry
        };
        favorites.updateItemMeta(productId, 'artworks', artworks2);
      }
    }
  },

  async retryArtworkUpload(productId, artworkIndex) {
    var favorites = Alpine.store('favorites');
    var item = favorites.items.find(function(i) { return i.key === productId; });
    if (!item || !item.artworks || !item.artworks[artworkIndex]) return;

    var aw = item.artworks[artworkIndex];
    if (aw.status !== 'error' || !aw._file) {
      this.errorMessage = 'Cannot retry — original file not available. Please re-select the file.';
      return;
    }

    // Set back to uploading
    var artworks = [...item.artworks];
    artworks[artworkIndex] = { ...artworks[artworkIndex], status: 'uploading' };
    favorites.updateItemMeta(productId, 'artworks', artworks);

    await this._uploadSingleFile(productId, artworkIndex, aw._file);
  },

  async removeArtwork(productId, artworkIndex) {
    var favorites = Alpine.store('favorites');
    var item = favorites.items.find(function(i) { return i.key === productId; });
    if (!item || !item.artworks) return;

    var aw = item.artworks[artworkIndex];
    var artworks = item.artworks.filter(function(_, idx) { return idx !== artworkIndex; });
    favorites.updateItemMeta(productId, 'artworks', artworks);

    // Best-effort delete from Supabase Storage if it was uploaded
    if (aw.storagePath && this.uploadApiUrl) {
      // No delete endpoint needed — files auto-clean after 7 days
      // and the storagePath won't be included in the submission payload
    }
  },

  updateArtworkPlacement(productId, artworkIndex, placement) {
    var favorites = Alpine.store('favorites');
    var item = favorites.items.find(function(i) { return i.key === productId; });
    if (!item || !item.artworks || !item.artworks[artworkIndex]) return;
    var artworks = [...item.artworks];
    artworks[artworkIndex] = { ...artworks[artworkIndex], placement: placement };
    favorites.updateItemMeta(productId, 'artworks', artworks);
  },

  async submitQuote() {
    this.submitting = true;
    this.errorMessage = '';
    this.successMessage = '';

    try {
      const favorites = Alpine.store('favorites');
      const chatQuote = Alpine.store('chatQuote');

      // Determine product source and set tracking label
      let products;
      let source = 'Quote List';

      if (chatQuote && chatQuote.active && chatQuote.count > 0) {
        products = chatQuote.getProductData();
        source = 'Chatbot';
      } else if (chatQuote && chatQuote.active) {
        // Chat active but no items (summary-only quote)
        products = [];
        source = 'Chatbot';
      } else {
        products = favorites.getProductData();
      }

      // Validate mystery product notes
      const mysteryNoNotes = products.find(p => p.handle === 'mystery-product' && (!p.notes || !p.notes.trim()));
      if (mysteryNoNotes) {
        this.errorMessage = 'Please add notes for the Mystery Product \u2014 include the brand, product name or SKU you require.';
        this.submitting = false;
        return;
      }

      if (source === 'Quote List') {
        const shortfall = favorites.moqShortfalls()[0];
        if (shortfall) {
          this.errorMessage = shortfall.title + ' total ' + shortfall.total + ' — minimum ' + shortfall.moq;
          this.submitting = false;
          return;
        }
      }

      // Validate artwork uploads are complete (check the raw item artworks, not the product data)
      var allItems = source === 'Chatbot' ? [] : favorites.items;
      for (var i = 0; i < allItems.length; i++) {
        var itm = allItems[i];
        if (itm.artworks && itm.artworks.length > 0) {
          var uploading = itm.artworks.filter(function(a) { return a.status === 'uploading'; });
          var errored = itm.artworks.filter(function(a) { return a.status === 'error'; });
          if (uploading.length > 0) {
            this.errorMessage = 'Please wait for uploads to finish before submitting.';
            this.submitting = false;
            return;
          }
          if (errored.length > 0) {
            this.errorMessage = 'Some artwork files failed to upload. Please retry or remove them before submitting.';
            this.submitting = false;
            return;
          }
        }
      }

      // Fresh token per attempt: Turnstile tokens are single-use and expire after
      // 300s, and this modal is routinely open far longer than that while artwork
      // uploads. Resolves to '' if anything goes wrong; the server rules.
      const turnstileToken = await getTurnstileToken(this.turnstileSiteKey, 'quote-request');
      // An empty token is not evidence of a bot on its own — it is also what a
      // customer whose challenge could not be shown produces. Send the distinction.
      const turnstileFailure = turnstileToken ? '' : getTurnstileFailure('quote-request');

      // POST to Vercel API endpoint — no base64, just file paths
      const response = await fetch(this.webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          turnstileToken: turnstileToken,
          turnstileFailure: turnstileFailure,
          name: this.formData.name,
          email: this.formData.email,
          phone: this.formData.phone,
          company: this.formData.company,
          description: this.formData.description,
          budget: this.formData.budget,
          inHandDate: this.formData.inHandDate,
          location: this.formData.location,
          heardAbout: this.formData.heardAbout,
          heardAboutDetail: this.formData.heardAboutDetail,
          attribution: readAttribution(),
          products: products,
          quoteSessionId: this.quoteSessionId,
          source: source,
          chatSessionId: chatQuote && chatQuote.active ? chatQuote.sessionId : null,
          chatSummary: chatQuote && chatQuote.active ? chatQuote.summary : null
        })
      });

      const result = await response.json();

      if (result.success) {
        if (result.artworkFailures && result.artworkFailures.length > 0) {
          this.successMessage = 'Quote submitted! Note: some artwork files could not be synced to our system. Our team has been notified.';
        } else {
          this.successMessage = 'Quote request submitted successfully!';
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'quote_request_submitted',
          quote_count: products.length,
          page_path: window.location.pathname,
          has_chat_quote: !!(chatQuote && chatQuote.active),
          source: source
        });
        // GA4 recommended-name lead event — parallel to the legacy event above so
        // existing GTM triggers keep working. value/currency omitted (no confirmed
        // quote value at submit time).
        window.dataLayer.push({
          event: 'generate_lead',
          lead_type: 'quote_request',
          quote_count: products.length,
          page_path: window.location.pathname,
          has_chat_quote: !!(chatQuote && chatQuote.active),
          source: source,
          heard_about_us: this.formData.heardAbout,
          // Enhanced Conversions for Leads — GTM reads user_data.{email,phone_number}, hashes client-side.
          user_data: { email: this.formData.email, phone_number: this.formData.phone }
        });
        this.resetForm();
        favorites.clear();
        if (chatQuote) chatQuote.clear();
      } else {
        console.error('Webhook error:', result);
        // Carry the server's message onto the error so the catch can show it. A
        // Turnstile rejection is retryable and must say so.
        const submitError = new Error(result.error || 'Submission failed');
        submitError.serverMessage = typeof result.error === 'string' ? result.error : '';
        throw submitError;
      }
    } catch (error) {
      console.error('Quote submission error:', error);
      this.errorMessage = (error && error.serverMessage)
        || 'There was an error submitting your request. Please try again or contact us directly.';
    } finally {
      this.submitting = false;
    }
  },

  // Clearing the detail on switch stops a stale referral name being submitted
  // against "Google search" after the customer changes their mind.
  selectHeardAbout(value) {
    this.formData.heardAbout = value;
    if (value !== 'Referral or word of mouth' && value !== 'Other') {
      this.formData.heardAboutDetail = '';
    }
  },

  resetForm() {
    this.formData = {
      name: '',
      email: '',
      phone: '',
      company: '',
      description: '',
      budget: 500,
      inHandDate: '',
      location: '',
      heardAbout: '',
      heardAboutDetail: ''
    };
    this.uploadedFile = null;
    this.uploadedFileName = '';
    this.quoteSessionId = '';
  }
});

var book_request_form_default = () => ({
  formData: {
    name: '',
    email: '',
    phone: '',
    company: '',
    projectType: '',
    quantityBand: '',
    timeline: '',
    brief: '',
    preferredTime: '',
    heardAbout: '',
    heardAboutDetail: ''
  },
  turnstileSiteKey: '',
  submitting: false,
  submitted: false,
  errorMessage: '',
  endpointUrl: '',
  stepError: '',   // inline validation message (single-page form)
  copied: false,

  // --- artwork step (optional, skippable) — kept OUTSIDE formData so the flat
  // submit payload stays byte-identical. Files upload to Supabase Storage via the
  // shared quote-artwork sign endpoint and are appended to the submit body as
  // artworkFiles; the server attaches them to the consult deal (best-effort). ---
  artworks: [],
  artworkError: '',
  uploadApiUrl: '',
  artworkMaxFiles: 5,
  artworkMaxBytes: 10 * 1024 * 1024,
  artworkAllowedTypes: ['image/png', 'image/jpeg', 'image/svg+xml', 'application/pdf', 'application/postscript', 'application/illustrator', 'application/x-eps'],
  artworkSessionId: (() => {
    // One id per page load, grouping this attempt's uploads (same fallback as attemptId).
    try { return crypto.randomUUID(); } catch (_) {}
    return 'bac-art-' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
  })(),

  // --- telemetry state: attempt id + start/submit signal for GTM/GA4 ---
  // 2026-07-24: form flattened from the 8-step funnel to a single page. formVersion
  // bumped so GA4 segments flat-form leads from the earlier stepped funnel (the
  // per-step step_view/complete/error events no longer fire; start + submit do).
  formVersion: '2026-07-24',
  attemptId: (() => {
    // One id per page load — lets analytics correlate a start with a later submit.
    try { return crypto.randomUUID(); } catch (_) {}
    return 'bac-' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
  })(),
  startedAt: null,       // ms of first real interaction (null until started)
  started: false,
  _seq: 0,               // monotonic per-attempt event counter

  get firstName() {
    return (this.formData.name || '').trim().split(/\s+/)[0] || '';
  },

  _now() { return Date.now(); },

  // Whole rounded seconds since a recorded ms timestamp (0 when unset).
  _elapsed(from) {
    return from ? Math.max(0, Math.round((this._now() - from) / 1000)) : 0;
  },

  // Fail-safe push to GTM's dataLayer — never throws into the form. Every event
  // carries the common params.
  track(event, params) {
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({
        event,
        form_id: 'book_a_call',
        form_version: this.formVersion,
        attempt_id: this.attemptId,
        event_seq: ++this._seq,
      }, params || {}));
    } catch (_) { /* telemetry must never break the form */ }
  },

  // First real interaction, fired once. Non-PII attribution only (source/medium/campaign).
  markStarted() {
    if (this.started) return;
    this.started = true;
    this.startedAt = this._now();
    // Warm the Turnstile script on first interaction — not on page load.
    preloadTurnstile(this.turnstileSiteKey);
    const a = (typeof readAttribution === 'function' ? readAttribution() : null) || {};
    this.track('book_a_call_start', {
      source: a.utm_source || null,
      medium: a.utm_medium || null,
      campaign: a.utm_campaign || null,
    });
  },

  init() {
    this.endpointUrl = this.$root.dataset.endpointUrl
      || 'https://print-room-chatbot-api.vercel.app/api/book-a-call';
    // Artwork sign endpoint: explicit data-upload-api-url override, else derived
    // from the API base (same origin as the book-a-call endpoint).
    this.uploadApiUrl = this.$root.dataset.uploadApiUrl
      || (this.endpointUrl.replace(/\/api\/book-a-call\/?$/, '') + '/api/quote-artwork-upload');
    this.turnstileSiteKey = this.$root.dataset.turnstileSiteKey || '';
    // Clear the referral/other detail when switching away.
    this.$watch('formData.heardAbout', (value) => {
      if (value !== 'Referral or word of mouth' && value !== 'Other') {
        this.formData.heardAboutDetail = '';
      }
    });
  },

  // Returns '' when the field group is valid, otherwise the message to show inline.
  // The groups (name / contact / project / heard / brief) are the required inputs;
  // validateAll() runs them in order for the single-page submit.
  validateStep(step) {
    const d = this.formData;
    switch (step) {
      case 1:
        return d.name.trim() ? '' : 'Please tell us your name.';
      case 2:
        if (!d.email.trim() || !/.+@.+\..+/.test(d.email)) return 'Please enter a valid email address.';
        if (!d.phone.trim()) return 'Please enter your phone number.';
        return '';
      case 5:
        if (!d.heardAbout) return 'Please pick an option.';
        if (d.heardAbout === 'Other' && !d.heardAboutDetail.trim()) return 'Please tell us how you found us.';
        return '';
      case 6:
        return d.brief.trim() ? '' : 'Please tell us a little about your brief.';
      default:
        return ''; // quantity/timeline, preferred time and artwork are optional
    }
  },

  // The required field groups, in the order they appear on the page.
  // projectType (group 3) is optional — server allows it empty too (book-a-call.ts).
  _requiredGroups: [1, 2, 5, 6],

  // First failing required group (its validateStep key), or 0 when the form is valid.
  validateAll() {
    for (const step of this._requiredGroups) {
      if (this.validateStep(step)) return step;
    }
    return 0;
  },

  // Single-page submit: validate everything at once, surface + focus the first
  // problem, otherwise send. Enter and the Submit button both land here.
  submitFlat() {
    const bad = this.validateAll();
    if (bad) {
      this.stepError = this.validateStep(bad);
      const focusFirst = () => {
        const map = { 1: '#bc-name', 2: '#bc-email', 5: '[name=bc-heard]', 6: '#bc-brief' };
        let sel = map[bad];
        if (bad === 2 && this.formData.email.trim() && /.+@.+\..+/.test(this.formData.email)) sel = '#bc-phone';
        const el = sel && this.$root && this.$root.querySelector(sel);
        if (el && el.focus) { el.focus(); if (el.scrollIntoView) el.scrollIntoView({ block: 'center' }); }
      };
      if (typeof this.$nextTick === 'function') this.$nextTick(focusFirst); else focusFirst();
      return;
    }
    this.stepError = '';
    this.submitBooking();
  },

  async copyEmail() {
    try {
      await navigator.clipboard.writeText('hello@theprint-room.co.nz');
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 1500);
    } catch (e) { /* clipboard unavailable — leave the note as-is */ }
  },

  // --- artwork upload: mirrors the quote form's per-file flow, minus the product
  // store. Files upload in the background; the submit is never blocked on them. ---
  handleArtworkFiles(event) {
    const input = event && event.target;
    const files = Array.from((input && input.files) || []);
    if (input) input.value = '';   // let the user re-select the same file later
    if (files.length === 0) return;
    this.artworkError = '';

    const remaining = this.artworkMaxFiles - this.artworks.length;
    if (remaining <= 0) {
      this.artworkError = 'You can attach up to ' + this.artworkMaxFiles + ' files.';
      return;
    }

    let accepted = 0;
    for (const file of files) {
      if (accepted >= remaining) break;
      if (file.size > this.artworkMaxBytes) {
        this.artworkError = '“' + file.name + '” is over 10MB.';
        continue;
      }
      if (file.type && this.artworkAllowedTypes.indexOf(file.type) === -1) {
        this.artworkError = '“' + file.name + '” isn’t a supported file type (PNG, JPG, SVG, PDF, AI or EPS).';
        continue;
      }
      const id = (() => { try { return crypto.randomUUID(); } catch (_) {} return 'aw-' + Math.random().toString(36).slice(2) + Date.now().toString(36); })();
      this.artworks.push({
        id,
        fileName: file.name,
        fileSize: file.size,
        mimeType: file.type || 'application/octet-stream',
        storagePath: null,
        status: 'uploading',
        _file: file,   // transient — dropped on success, kept on error for retry
      });
      accepted++;
      this._uploadArtwork(id, file);   // background — don't await
    }

    if (files.length > remaining) {
      this.artworkError = 'You can attach up to ' + this.artworkMaxFiles + ' files — extras were skipped.';
    }
  },

  // Patch an entry by id (immutable replace — reactive-safe and robust to reordering).
  _patchArtwork(id, fields) {
    const i = this.artworks.findIndex((a) => a.id === id);
    if (i !== -1) this.artworks[i] = Object.assign({}, this.artworks[i], fields);
  },

  async _uploadArtwork(id, file) {
    try {
      // 1. Mint a signed upload URL (server enforces type + rate limits).
      const signedRes = await fetch(this.uploadApiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fileName: file.name,
          mimeType: file.type || 'application/octet-stream',
          quoteSessionId: this.artworkSessionId,
          productHandle: null,
          fileSize: file.size,
        }),
      });
      if (!signedRes.ok) {
        const errData = await signedRes.json().catch(() => ({}));
        throw new Error(errData.error || 'Failed to get upload URL');
      }
      const signed = await signedRes.json();

      // 2. PUT the file straight to Supabase Storage.
      const uploadRes = await fetch(signed.signedUrl, {
        method: 'PUT',
        headers: { 'Content-Type': file.type || 'application/octet-stream' },
        body: file,
      });
      if (!uploadRes.ok) throw new Error('Storage upload failed: ' + uploadRes.status);

      // 3. Mark done — only done+storagePath entries are submitted.
      this._patchArtwork(id, { storagePath: signed.storagePath, status: 'done', _file: null });
    } catch (err) {
      console.error('Book-a-call artwork upload failed:', err);
      this._patchArtwork(id, { status: 'error' });
    }
  },

  removeArtwork(index) {
    this.artworks.splice(index, 1);
  },

  retryArtwork(index) {
    const entry = this.artworks[index];
    if (!entry || entry.status !== 'error' || !entry._file) {
      this.artworkError = 'Please re-select the file to retry.';
      return;
    }
    const file = entry._file;
    this.artworks[index] = Object.assign({}, entry, { status: 'uploading' });
    this._uploadArtwork(entry.id, file);   // background
  },

  async submitBooking() {
    this.submitting = true;
    this.errorMessage = '';
    try {
      // Fresh token per attempt: Turnstile tokens are single-use and expire after
      // 300s. Resolves to '' if anything at all goes wrong; the server rules.
      const turnstileToken = await getTurnstileToken(this.turnstileSiteKey, 'book-a-call');
      // See the quote form: '' alone cannot tell a blocked customer from a bot.
      const turnstileFailure = turnstileToken ? '' : getTurnstileFailure('book-a-call');
      const response = await fetch(this.endpointUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          turnstileToken: turnstileToken,
          turnstileFailure: turnstileFailure,
          name: this.formData.name,
          email: this.formData.email,
          phone: this.formData.phone,
          company: this.formData.company,
          projectType: this.formData.projectType,
          quantityBand: this.formData.quantityBand,
          timeline: this.formData.timeline,
          brief: this.formData.brief,
          preferredTime: this.formData.preferredTime,
          heardAbout: this.formData.heardAbout,
          heardAboutDetail: this.formData.heardAboutDetail,
          attribution: readAttribution(),
          artworkFiles: this.artworks
            .filter((a) => a.status === 'done' && a.storagePath)
            .map((a) => ({ storagePath: a.storagePath, fileName: a.fileName }))
        })
      });
      const result = await response.json();
      if (result.success) {
        this.submitted = true;
        this.track('book_a_call_submit_success', {
          seconds_total: this._elapsed(this.startedAt),
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'generate_lead',
          lead_type: 'book_a_call',
          form: 'book-a-call',
          page_path: window.location.pathname,
          heard_about_us: this.formData.heardAbout,
          // Enhanced Conversions for Leads — GTM reads user_data.{email,phone_number}, hashes client-side.
          user_data: { email: this.formData.email, phone_number: this.formData.phone }
        });
      } else {
        // Carry the server's message onto the error so the catch can show it. A
        // Turnstile rejection is retryable and must say so — the generic "contact
        // us directly" copy would send a fixable failure to the wrong place.
        const submitError = new Error(result.error || 'Submission failed');
        submitError.serverMessage = typeof result.error === 'string' ? result.error : '';
        throw submitError;
      }
    } catch (error) {
      this.track('book_a_call_submit_error', {
        seconds_total: this._elapsed(this.startedAt),
      });
      console.error('Book-a-call submission error:', error);
      this.errorMessage = (error && error.serverMessage)
        || 'There was an error submitting your request. Please try again or email hello@theprint-room.co.nz.';
    } finally {
      this.submitting = false;
    }
  }
});

// _src/js/components/age-check.js
var age_check_default = ({ mode, dateFormat, minimumAge, redirectURL, enabled }) => {
  return {
    authenticated: false,
    mode,
    dateFormat,
    minimumAge,
    redirectURL,
    month: "",
    day: "",
    year: "",
    date: "",
    enabled,
    sectionId: null,
    storageKey: null,
    boundOnSectionSelect: null,
    boundOnSectionDeselect: null,
    get fullDate() {
      return `${this.month}/${this.day}/${this.year}`;
    },
    init() {
      this.sectionId = this.$root.id;
      this.storageKey = `switch-age-check-${this.sectionId}`;
      if (window.location.pathname === "/challenge") return;
      if (Shopify.designMode) {
        Alpine.store("modals").removeExistingContents("modal", "#ageCheck");
      }
      initTeleport(this.$root);
      Alpine.store("modals").register("ageCheck", "modal");
      if (!Shopify.designMode) {
        if (getExpiringStorageItem(this.storageKey) !== "approved") {
          Alpine.store("modals").open("ageCheck");
        }
      } else {
        if (window.theme.designMode.selected === this.sectionId) {
          if (this.enabled === true) {
            Alpine.store("modals").open("ageCheck");
          } else {
            Alpine.store("modals").close("ageCheck");
          }
        }
        this.boundOnSectionSelect = this.onSectionSelect.bind(this);
        this.boundOnSectionDeselect = this.onSectionDeselect.bind(this);
        document.addEventListener(
          "shopify:section:select",
          this.boundOnSectionSelect
        );
        document.addEventListener(
          "shopify:section:deselect",
          this.boundOnSectionDeselect
        );
      }
      if (this.redirectURL === null) {
        this.redirectURL = "https://www.google.com";
      }
      if (this.mode === "dob") {
        this.date = /* @__PURE__ */ new Date();
        setTimeout(() => this.setUpDOB(), 100);
      }
    },
    onSectionSelect(e) {
      if (!e.target.contains(this.$root)) return;
      if (!this.enabled) return;
      Alpine.store("modals").open("ageCheck");
    },
    onSectionDeselect(e) {
      if (!e.target.contains(this.$root)) return;
      this.$store.modals.close("ageCheck");
    },
    approveEntry() {
      Alpine.store("modals").close("ageCheck");
      if (!Shopify.designMode) {
        setExpiringStorageItem(this.storageKey, "approved", daysInMs(30));
      }
    },
    denyEntry() {
      window.location = this.redirectURL;
    },
    checkInput(name) {
      switch (name) {
        case "day":
          return parseInt(this.day) > 0 && parseInt(this.day) < 32 ? true : false;
        case "month":
          return parseInt(this.month) > 0 && parseInt(this.month) < 13 ? true : false;
        case "year":
          return parseInt(this.year) < this.date.getFullYear() && parseInt(this.year) > 1900 ? true : false;
      }
      return true;
    },
    checkAge() {
      const currentDate = Math.round(this.date.getTime() / 1e3);
      const enteredDate = Math.round(
        (/* @__PURE__ */ new Date(`${this.fullDate}`)).getTime() / 1e3
      );
      const yearInSeconds = 31536e3;
      const difference = Math.floor(
        (currentDate - enteredDate) / yearInSeconds
      );
      if (difference > parseInt(this.minimumAge, 10)) {
        this.approveEntry();
      } else {
        this.denyEntry();
      }
    },
    setUpDOB() {
      const container = document.getElementById(`dob-form-${this.sectionId}`);
      container.addEventListener("input", (e) => {
        const target = e.srcElement || e.target;
        const maxLength = parseInt(target.attributes["maxlength"].value, 10);
        const targetLength = target.value.length;
        if (targetLength >= maxLength) {
          const valid = this.checkInput(target.getAttribute("name"));
          if (!valid) {
            target.value = "";
            return false;
          }
          let next = target.closest(".input-grid-item");
          while (next = next.nextElementSibling) {
            if (next == null) break;
            let input = next.querySelector("input");
            if (input !== null) {
              input.focus();
              break;
            }
          }
        } else if (targetLength === 0) {
          let previous = target.closest(".input-grid-item");
          while (previous = previous.previousElementSibling) {
            if (previous == null) break;
            const input = previous.querySelector("input");
            if (input !== null) {
              input.focus();
              break;
            }
          }
        }
        if (this.checkInput("day") && this.checkInput("month") && this.checkInput("year")) {
          setTimeout(() => this.checkAge(), 500);
        }
      });
    },
    destroy() {
      document.removeEventListener(
        "shopify:section:select",
        this.boundOnSectionSelect
      );
      document.removeEventListener(
        "shopify:section:deselect",
        this.boundOnSectionDeselect
      );
    }
  };
};

// _src/js/components/free-shipping-bar.js
var free_shipping_bar_default = () => ({
  contentHTML: null,
  boundOnCartUpdate: null,
  init() {
    this.boundOnCartUpdate = this.onCartUpdate.bind(this);
    window.addEventListener(
      "baseline:cart:afteradditem",
      this.boundOnCartUpdate
    );
    window.addEventListener(
      "baseline:cart:cartqtychange",
      this.boundOnCartUpdate
    );
    window.addEventListener("baseline:cart:update", this.boundOnCartUpdate);
  },
  async onCartUpdate() {
    const updatedSection = await freshHTML(
      getURLWithParams(window.theme.routes.root_url, {
        // eslint-disable-next-line camelcase
        section_id: this.$root.id
      })
    );
    this.contentHTML = querySelectorInHTMLString(
      "[data-content]",
      updatedSection
    ).innerHTML;
    const scrollingTextContainerEl = this.$root.querySelector(
      "scrolling-items-container"
    );
    if (scrollingTextContainerEl) {
      await this.$nextTick();
      scrollingTextContainerEl.dispatchEvent(
        new CustomEvent("scrolling-items:change")
      );
    }
  },
  destroy() {
    window.removeEventListener(
      "baseline:cart:afteradditem",
      this.boundOnCartUpdate
    );
    window.removeEventListener(
      "baseline:cart:cartqtychange",
      this.boundOnCartUpdate
    );
    window.removeEventListener("baseline:cart:update", this.boundOnCartUpdate);
  }
});

// _src/js/components/cart-items.js
var cart_items_default = () => ({
  itemsRoot: null,
  loading: null,
  boundOnCartQuantityChange: null,
  init() {
    this.itemsRoot = this.$root;
    this.boundOnCartQuantityChange = this.onCartQuantityChange.bind(this);
    window.addEventListener(
      "baseline:cart:afteradditem",
      this.boundOnCartQuantityChange
    );
    window.addEventListener(
      "baseline:cart:cartqtychange",
      this.boundOnCartQuantityChange
    );
    window.addEventListener(
      "baseline:cart:update",
      this.boundOnCartQuantityChange
    );
    document.addEventListener("baseline:cart:lock", () => {
      this.loading = true;
    });
    document.addEventListener("baseline:cart:unlock", () => {
      this.loading = false;
    });
  },
  onCartQuantityChange(e) {
    Alpine.morph(
      this.itemsRoot,
      querySelectorInHTMLString(
        "[data-cart-items]",
        e.detail.response.sections["cart-items"]
      ).outerHTML,
      {
        updating(el, toEl, childrenOnly, skip) {
          if (el.nodeType === 1 && el.hasAttribute("ready")) {
            toEl.setAttribute("ready", "");
          }
        }
      }
    );
    this.$nextTick(() => {
      this.itemsRoot.querySelectorAll("input").forEach((inputEl) => {
        inputEl.value = inputEl.getAttribute("value");
        inputEl.dispatchEvent(new Event("input"));
      });
    });
    this.updateLiveRegion(
      parseDOMFromString(e.detail.response.sections["cart-live-region"]).firstElementChild.textContent
    );
    if (e.detail.originalTarget) {
      this.$nextTick(() => {
        if (!this.itemsRoot.contains(e.detail.originalTarget)) {
          let focusRoot;
          if (this.itemsRoot.closest('[role="dialog"]')) {
            focusRoot = this.itemsRoot.closest('[role="dialog"]').parentNode;
          } else {
            focusRoot = this.itemsRoot;
          }
          this.$focus.within(focusRoot).first();
        }
      });
    }
    const itemsRootEl = this.itemsRoot;
    switch (e.type) {
      case "baseline:cart:afteradditem":
        document.dispatchEvent(
          new CustomEvent("theme:product:add", {
            detail: {
              cartItemCount: window.theme.cartItemCount,
              itemsRootEl,
              lineItemEl: document.querySelector(
                `[data-line-item-key="${e.detail.response.key}"]`
              ) || null,
              variantId: e.detail.response.variant_id,
              key: e.detail.response.key,
              formEl: document.getElementById(e.detail.sourceId),
              get cartPromise() {
                return fetch(
                  window.theme.routes.cart_url,
                  fetchConfigDefaults()
                ).then((res) => res.json()).then((cart) => cart).catch(
                  (error) => console.error(
                    "Error fetching cart in `theme:product:add`",
                    error
                  )
                );
              }
            }
          })
        );
        break;
      case "baseline:cart:cartqtychange":
        document.dispatchEvent(
          new CustomEvent("theme:line-item:change", {
            detail: {
              cartItemCount: e.detail.response.item_count,
              itemsRootEl,
              lineItemEl: document.querySelector(
                `[data-line-item-key="${e.detail.key}"]`
              ) || null,
              variantId: e.detail.variantId,
              key: e.detail.key,
              quantity: e.detail.quantity,
              previousQuantity: e.detail.previousQuantity,
              cart: e.detail.response
            }
          })
        );
        break;
      case "baseline:cart:update":
        document.dispatchEvent(
          new CustomEvent("theme:cart:update", {
            detail: {
              cartItemCount: window.theme.cartItemCount,
              itemsRootEl,
              get cartPromise() {
                return fetch(
                  window.theme.routes.cart_url,
                  fetchConfigDefaults()
                ).then((res) => res.json()).then((cart) => cart).catch(
                  (error) => console.error(
                    "Error fetching cart in `theme:cart:update`",
                    error
                  )
                );
              }
            }
          })
        );
        break;
    }
  },
  updateLiveRegion(liveRegionText) {
    if (!liveRegionText) return;
    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.textContent = liveRegionText;
    cartStatus.setAttribute("aria-hidden", false);
    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1e3);
  },
  destroy() {
    window.removeEventListener(
      "baseline:cart:afteradditem",
      this.boundOnCartQuantityChange
    );
    window.removeEventListener(
      "baseline:cart:cartqtychange",
      this.boundOnCartQuantityChange
    );
    window.removeEventListener(
      "baseline:cart:update",
      this.boundOnCartQuantityChange
    );
  }
});

// _src/js/components/cart-item.js
var cart_item_default = (key) => ({
  quantity: null,
  previousQuantity: null,
  key,
  locked: false,
  errorMessage: null,
  init() {
    document.addEventListener("baseline:cart:lock", () => {
      this.locked = true;
    });
    document.addEventListener("baseline:cart:unlock", () => {
      this.locked = false;
    });
  },
  async itemQuantityChange() {
    if (this.locked || this.loading) return;
    if (this.$refs.quantityInput.hasAttribute("data-last-value")) {
      if (this.quantity === Number(this.$refs.quantityInput.dataset.lastValue)) {
        return;
      }
    }
    this.locked = true;
    this.loading = true;
    const request = {
      ...fetchConfigDefaults("application/javascript"),
      body: JSON.stringify({
        id: this.key,
        quantity: this.quantity,
        sections: "cart-items,cart-footer,cart-item-count,cart-live-region",
        // eslint-disable-next-line camelcase
        sections_url: window.location.pathname
      })
    };
    try {
      const response = await fetch(theme.routes.cart_change_url, request);
      const data = await response.json();
      if (data.status === 422) {
        this.errorMessage = data.message;
        this.quantity = this.previousQuantity;
        document.dispatchEvent(
          new CustomEvent("theme:line-item:error", {
            detail: {
              message: this.errorMessage,
              itemsRootEl: this.itemsRoot,
              lineItemEl: document.querySelector(`[data-line-item-key="${this.key}"]`) || null,
              variantId: Number(this.$refs.quantityInput.dataset.variantId),
              key: this.key,
              quantity: this.quantity
            }
          })
        );
      } else {
        this.errorMessage = null;
        document.body.dispatchEvent(
          new CustomEvent("baseline:cart:cartqtychange", {
            bubbles: true,
            detail: {
              response: data,
              key: this.key,
              quantity: this.quantity,
              previousQuantity: this.previousQuantity,
              variantId: Number(this.$refs.quantityInput.dataset.variantId),
              originalTarget: this.$refs.quantityControl
            }
          })
        );
      }
    } catch (e) {
      console.error(e);
      document.getElementById("cart-errors").textContent = theme.strings.cartError;
      document.dispatchEvent(
        new CustomEvent("theme:cart:error:other", {
          detail: {
            message: theme.strings.cartError,
            error: e
          }
        })
      );
    } finally {
      this.locked = false;
      this.loading = false;
    }
  },
  removeItem() {
    const visibleQtyControl = Array.from(
      this.$root.querySelectorAll('[x-data="CartItemQuantity"]')
    ).filter((el) => el.offsetParent)[0];
    visibleQtyControl.dispatchEvent(new CustomEvent("remove"));
  }
});

// _src/js/components/core/quantity.js
var quantity_default = {
  adjustQuantity(adjustCb) {
    if (typeof this.previousQuantity !== "undefined") {
      this.previousQuantity = this.quantity;
    }
    const quantityBeforeAdjustment = this.quantity;
    console.log('adjustQuantity called, before:', quantityBeforeAdjustment);
    adjustCb();
    console.log('After adjustCb, input value:', this.$refs.quantityInput.value);
    // Manually sync quantity from input value after adjustment
    this.quantity = parseInt(this.$refs.quantityInput.value) || 1;
    console.log('After sync, quantity:', this.quantity);
    this.dispatchInputEvent();
    if (this.quantity === quantityBeforeAdjustment) return;
    this.$nextTick(() => {
      this.dispatchChangeEvent();
    });
  },
  increment() {
    this.adjustQuantity(() => {
      this.$refs.quantityInput.stepUp();
    });
  },
  decrement() {
    this.adjustQuantity(() => {
      this.$refs.quantityInput.stepDown();
    });
  },
  dispatchInputEvent() {
    this.$refs.quantityInput.dispatchEvent(new Event("input"));
  },
  dispatchChangeEvent() {
    this.$refs.quantityInput.dispatchEvent(new Event("change"));
  }
};

// _src/js/components/cart-item-quantity.js
var cart_item_quantity_default = () => ({
  remove() {
    this.adjustQuantity(() => {
      this.$refs.quantityInput.value = 0;
    });
  },
  ...quantity_default
});

// _src/js/components/cart-footer.js
var cart_footer_default = () => {
  return {
    footerRoot: null,
    _morphFooter(e) {
      const newFooterSection = querySelectorInHTMLString(
        "[data-cart-footer]",
        e.detail.response.sections["cart-footer"]
      );
      Alpine.morph(
        this.footerRoot,
        newFooterSection ? newFooterSection.outerHTML : "",
        {
          updating(el, toEl, childrenOnly, skip) {
            if (el.classList && el.classList.contains("additional-checkout-buttons")) {
              skip();
            }
            if (el.nodeType === 1 && el.hasAttribute("ready")) {
              toEl.setAttribute("ready", "");
            }
          }
        }
      );
    },
    init() {
      this.footerRoot = this.$root;
      window.addEventListener("baseline:cart:afteradditem", (e) => {
        this._morphFooter(e);
      });
      window.addEventListener("baseline:cart:cartqtychange", (e) => {
        this._morphFooter(e);
      });
      window.addEventListener("baseline:cart:update", (e) => {
        this._morphFooter(e);
      });
    }
  };
};

// _src/js/components/cart-note.js
var cart_note_default = () => {
  return {
    updating: false,
    note: "",
    init() {
      this.note = this.$root.value;
      this.$watch("note", (value, oldValue) => {
        if (value !== oldValue) {
          this.updateNote();
        }
      });
    },
    async updateNote() {
      this.updating = true;
      await fetch(theme.routes.cart_update_url, {
        ...fetchConfigDefaults(),
        body: JSON.stringify({
          note: this.$root.value
        })
      });
      this.updating = false;
    }
  };
};

// _src/js/components/header.js
var header_default = () => ({
  isStuck: false,
  overlayHeaderWithSticky: null,
  overlayTextColor: null,
  init() {
    this.overlayHeaderWithSticky = this.$root.dataset.overlayHeaderWithSticky === "true";
    if (this.overlayHeaderWithSticky) {
      this.setUpOverlayWithSticky();
    }
  },
  setUpOverlayWithSticky() {
    const positionerEl = document.createElement("div");
    positionerEl.id = "sticky-positioner";
    document.body.insertBefore(
      positionerEl,
      this.$root.closest(".shopify-section")
    );
    const observer = new IntersectionObserver(([e]) => {
      e.intersectionRatio === 0 ? this.isStuck = true : this.isStuck = false;
    });
    observer.observe(positionerEl);
    this.overlayTextColor = this.$root.dataset.overlayTextColorScheme;
    this.updateColorScheme(this.isStuck);
    this.$watch("isStuck", (value) => {
      this.updateColorScheme(value);
    });
  },
  updateColorScheme(isStuck) {
    if (isStuck) {
      this.$refs.header.setAttribute("data-color-scheme", "");
      this.$refs.header.classList.remove("bg-transparent");
      this.$refs.header.classList.add("bg-scheme-background");
    } else {
      this.$refs.header.setAttribute(
        "data-color-scheme",
        this.overlayTextColor
      );
      this.$refs.header.classList.remove("bg-scheme-background");
      this.$refs.header.classList.add("bg-transparent");
    }
  }
});

// _src/js/components/video.js
var video_default = (mode = "preview") => ({
  player: null,
  enabled: false,
  playing: false,
  id: "",
  playback: "inline",
  mode,
  init() {
    this.id = this.$root.id;
    document.body.addEventListener("pauseAllMedia", (e) => {
      if (e.detail !== null && e.detail.id === this.$root.id) {
        return;
      }
      if (this.mode === "autoplay") return;
      this.pause();
    });
    this.$watch("enabled", (value) => {
      if (value === true) {
        this.player = this.$root.querySelector("[\\@play][\\@pause]");
        this.player.addEventListener("playing", () => {
          this.playing = true;
        });
        this.player.addEventListener("paused", () => {
          this.playing = false;
        });
      }
    });
    this.$watch("playing", (value) => {
      if (value === true) {
        this.dispatchPauseAllMediaEvent();
      }
    });
    this.productMediaWrapper = this.$root.closest(
      "[data-product-single-media-wrapper]"
    );
    if (this.productMediaWrapper !== null) {
      this.setUpProductMediaListeners();
    }
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:unload", (e) => {
        if (e.target.contains(this.$root) && this.player) {
          this.player.dispatchEvent(new CustomEvent("deinit"));
        }
      });
    }
    if (this.mode === "autoplay") {
      this.enable();
    }
    this.$nextTick(() => {
      this.checkImagesLoaded();
    });
  },
  checkImagesLoaded() {
    const images = this.$root.querySelectorAll("img.track-loaded");
    images.forEach((image) => {
      if (image.complete) {
        image.classList.add("is-complete");
      } else {
        image.addEventListener("load", () => {
          image.classList.add("is-complete");
        });
      }
    });
  },
  enable() {
    if (this.playback === "modal") {
      if (!this.$store.modals.modals[this.id]) {
        this.$store.modals.register(this.id, "modal");
      }
      this.dispatchPauseAllMediaEvent();
      this.$store.modals.open(this.id);
    } else {
      this.enabled = true;
    }
  },
  dispatchPauseAllMediaEvent() {
    document.body.dispatchEvent(
      new CustomEvent("pauseAllMedia", {
        detail: {
          id: this.$root.id
        }
      })
    );
  },
  play() {
    if (this.enabled === false || this.player === null) return;
    this.player.dispatchEvent(new CustomEvent("play"));
  },
  pause() {
    if (this.enabled === false || this.player === null) return;
    this.player.dispatchEvent(new CustomEvent("pause"));
  },
  setUpProductMediaListeners() {
    this.productMediaWrapper.addEventListener("mediaHidden", () => {
      this.pause();
    });
    this.productMediaWrapper.addEventListener("mediaVisible", () => {
    });
  }
});

// _src/js/components/product-media-video.js
var product_media_video_default = () => ({
  player: null,
  productMediaWrapper: null,
  enabled: false,
  playing: false,
  init() {
    document.body.addEventListener("pauseAllMedia", (e) => {
      if (e.detail !== null && e.detail.id === this.$root.id) {
        return;
      }
      this.pause();
    });
    this.$watch("enabled", (value) => {
      if (value === true) {
        this.player = this.$root.querySelector("[\\@play][\\@pause]");
        this.player.addEventListener("playing", () => {
          this.playing = true;
        });
        this.player.addEventListener("paused", () => {
          this.playing = false;
        });
      }
    });
    this.$watch("playing", (value) => {
      if (value === true) {
        this.dispatchPauseAllMediaEvent();
      }
    });
    this.productMediaWrapper = this.$root.closest(
      "[data-product-single-media-wrapper]"
    );
    if (this.productMediaWrapper) {
      this.setUpProductMediaListeners();
    }
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:unload", (e) => {
        if (e.target.contains(this.$root) && this.player) {
          this.player.dispatchEvent(new CustomEvent("deinit"));
        }
      });
    }
  },
  setUpProductMediaListeners() {
    this.productMediaWrapper.addEventListener("mediaHidden", () => {
      this.pause();
    });
    this.productMediaWrapper.addEventListener("mediaVisible", () => {
      this.play();
    });
  },
  enable() {
    this.enabled = true;
  },
  dispatchPauseAllMediaEvent() {
    document.body.dispatchEvent(
      new CustomEvent("pauseAllMedia", {
        detail: {
          id: this.$root.id
        }
      })
    );
  },
  play() {
    if (this.enabled === false || this.player === null) return;
    this.player.dispatchEvent(new CustomEvent("play"));
  },
  pause() {
    if (this.enabled === false || this.player === null) return;
    this.player.dispatchEvent(new CustomEvent("pause"));
  }
});

// _src/js/components/html-video.js
var html_video_default = () => ({
  init() {
    this.$refs.video.addEventListener("play", () => {
      this.$root.dispatchEvent(
        new CustomEvent("playing", {
          bubbles: true
        })
      );
    });
    this.$refs.video.addEventListener("pause", () => {
      this.$root.dispatchEvent(
        new CustomEvent("paused", {
          bubbles: true
        })
      );
    });
    if (this.$refs.video.autoplay) {
      this.$nextTick(() => {
        this.$refs.video.play();
      });
    }
  },
  play() {
    this.$refs.video.play();
  },
  pause() {
    this.$refs.video.pause();
  }
});

// _src/js/components/filterable.js
var filterable_default = () => ({
  filtersOpen: false,
  sortOpen: false,
  filtersCache: [],
  loading: false,
  focusedBeforeUpdate: null,
  searchParams: null,
  countHTML: null,
  filtersFormHTML: null,
  resultsHTML: null,
  drawerToggleHTML: null,
  afterUpdateCallback: null,
  isMdBreakpoint: window.isMdBreakpoint(),
  mdBreakpointMQL: window.mdBreakpointMQL(),
  boundOnHistoryChange: null,
  clickOutside(event, property, sidebarOnDesktop) {
    if (!(sidebarOnDesktop && this.isMdBreakpoint)) {
      event.preventDefault();
    }
    if (event.target && (event.target === this.$refs.filterDropDownToggle || event.target === this.$refs.sortDropDownToggle))
      return;
    this[property] = false;
  },
  focusOut(event, property) {
    if (event.relatedTarget) {
      if (event.relatedTarget === this.$refs.filterDropDownToggle || event.relatedTarget === this.$refs.sortDropDownToggle)
        return;
      const dropdownParent = event.relatedTarget.closest(
        "[data-filterable-dropdown]"
      );
      if (!dropdownParent) {
        this[property] = false;
      }
    }
  },
  onEscape() {
    if (this.filtersOpen) {
      this.filtersOpen = false;
      this.$refs.filterDropDownToggle.focus();
    }
    if (this.sortOpen) {
      this.sortOpen = false;
      this.$refs.sortToggle.focus();
    }
  },
  init() {
    this.isMdBreakpoint = this.mdBreakpointMQL.matches;
    this.mdBreakpointMQL.addEventListener("change", (e) => {
      this.isMdBreakpoint = e.matches;
    });
    this.$root.addEventListener("baseline:filterable:open-filters", () => {
      this.filtersOpen = true;
    });
    this.boundOnHistoryChange = this.onHistoryChange.bind(this);
    window.addEventListener("popstate", this.boundOnHistoryChange);
    this.$watch("sortOpen", (value) => {
      if (value === true && this.filtersOpen === true) {
        this.filtersOpen = false;
      }
    });
    this.$watch("filtersOpen", (value) => {
      if (value === true && this.sortOpen === true) {
        this.sortOpen = false;
      }
    });
    this.$watch("searchParams", this.onSearchParamsUpdate.bind(this));
  },
  async onSearchParamsUpdate(value, oldValue) {
    if (value === oldValue) return;
    const updatedHTML = await fetchHTML(
      currentURLAddingParams(
        [...value, ["section_id", getSectionId(this.$root)]],
        true
      )
    );
    if (this.$root.querySelector(`[data-fragment-id="count"]`)) {
      this.countHTML = querySelectorInHTMLString(
        `[data-fragment-id="count"]`,
        updatedHTML
      ).innerHTML;
    }
    if (this.$root.querySelector(`[data-fragment-id="drawer-toggle"]`)) {
      this.drawerToggleHTML = querySelectorInHTMLString(
        `[data-fragment-id="drawer-toggle"]`,
        updatedHTML
      ).innerHTML;
    }
    const filterFormFragmentIds = [
      "filters-form-sidebar",
      "filters-form-filters-drop-down",
      "filters-form-sort-drop-down",
      "filters-form-drawer"
    ];
    for (const fragmentId of filterFormFragmentIds) {
      let fragmentEl, updatedFormFragmentEl;
      if (fragmentId === "filters-form-drawer") {
        fragmentEl = document.getElementById("filters-form-drawer");
        if (!fragmentEl) continue;
        updatedFormFragmentEl = querySelectorInHTMLString(
          `[data-template-fragment-id="${fragmentId}"]`,
          updatedHTML
        )?.content.firstElementChild.querySelector(
          `[data-fragment-id="${fragmentId}"]`
        );
        if (!updatedFormFragmentEl) continue;
      } else {
        fragmentEl = this.$root.querySelector(
          `[data-fragment-id="${fragmentId}"]`
        );
        if (!fragmentEl) continue;
        updatedFormFragmentEl = querySelectorInHTMLString(
          `[data-fragment-id="${fragmentId}"]`,
          updatedHTML
        ) || null;
        if (!updatedFormFragmentEl) continue;
      }
      fragmentEl.querySelectorAll("[data-filterable-filter-fragment]").forEach((filterableFragmentEl) => {
        const updatedFragmentEl = updatedFormFragmentEl.querySelector(
          `[data-filterable-filter-fragment="${filterableFragmentEl.getAttribute(
            "data-filterable-filter-fragment"
          )}"`
        );
        if (updatedFragmentEl)
          filterableFragmentEl.innerHTML = updatedFragmentEl.innerHTML;
      });
    }
    this.resultsHTML = querySelectorInHTMLString(
      `[data-fragment-id="results"]`,
      updatedHTML
    ).innerHTML;
    this.afterUpdate();
  },
  // beforeUpdate() {},
  afterUpdate() {
    if (this.focusedBeforeUpdate && document.getElementById(this.focusedBeforeUpdate)) {
      const target = document.getElementById(this.focusedBeforeUpdate);
      this.$focus.focus(target);
      if (target.tagName === "INPUT" && target.type === "text") {
        target.select();
      }
      this.focusedBeforeUpdate = null;
    }
    if (!this.historyChanged) {
      this.updateURLHash(this.searchParams);
    } else {
      this.historyChanged = false;
    }
    this.loading = false;
    if (this.afterUpdateCallback) {
      this.$nextTick(() => {
        this.afterUpdateCallback();
        this.afterUpdateCallback = null;
      });
    }
  },
  filterFormSubmit(event) {
    let form = event.target.closest("form");
    if (event.target.hasAttribute("form")) {
      const formId = event.target.getAttribute("form");
      form = document.getElementById(formId);
    }
    if (this.loading || !form) return;
    this.loading = true;
    if (document.activeElement && this.$root.contains(document.activeElement)) {
      const targetId = document.activeElement.getAttribute("id");
      if (targetId) {
        this.focusedBeforeUpdate = targetId;
      }
    }
    const formData = new FormData(form);
    this.searchParams = new URLSearchParams(formData);
    if (event.target.name && event.target.name === "sort_by") {
      this.afterUpdateCallback = () => {
        this.sortOpen = false;
      };
    }
  },
  clearAllFilters() {
    this.searchParams = new URL(this.$event.currentTarget.href).searchParams;
  },
  updateURLHash(searchParams) {
    const searchParamsString = searchParams.toString();
    history.pushState(
      { searchParamsString },
      "",
      `${window.location.pathname}${searchParamsString && "?".concat(searchParamsString)}`
    );
  },
  onHistoryChange(event) {
    this.historyChanged = true;
    this.searchParams = event.state.searchParams || "";
  },
  destroy() {
    window.removeEventListener("popstate", this.boundOnHistoryChange);
  }
});

// _src/js/components/range-control.js
var range_control_default = (min, max, start, end) => ({
  min,
  max,
  valueA: start,
  valueB: end,
  ready: false,
  ignoreRangeStart: false,
  ignoreRangeEnd: false,
  get rangeStart() {
    return Math.min(this.valueA, this.valueB);
  },
  set rangeStart(value) {
    if (value >= this.rangeEnd) return;
    if (this.valueA < this.valueB) {
      this.valueA = value;
    } else {
      this.valueB = value;
    }
  },
  get rangeEnd() {
    return Math.max(this.valueA, this.valueB);
  },
  set rangeEnd(value) {
    if (value <= this.rangeStart) return;
    if (this.valueA > this.valueB) {
      this.valueA = value;
    } else {
      this.valueB = value;
    }
  },
  get rangeStartInMajorUnits() {
    return this.rangeStart / 100;
  },
  get rangeEndInMajorUnits() {
    return this.rangeEnd / 100;
  },
  get range() {
    return this.rangeEnd - this.rangeStart;
  },
  get rangeStartInPercent() {
    return this.normalize(this.rangeStart);
  },
  get rangeEndInPercent() {
    return this.normalize(this.rangeEnd);
  },
  get rangeInPercent() {
    return this.rangeEndInPercent - this.rangeStartInPercent;
  },
  get valueCenter() {
    return this.rangeStart + this.range / 2;
  },
  set valueCenter(value) {
    const proposedRangeStart = Math.round((value - this.range / 2) / 100) * 100;
    const proposedRangeEnd = Math.round((value + this.range / 2) / 100) * 100;
    if (proposedRangeStart < this.min || proposedRangeEnd > this.max) {
      return;
    }
    this.rangeStart = proposedRangeStart;
    this.rangeEnd = proposedRangeEnd;
  },
  init() {
    this.$watch("rangeStart", (value, oldValue) => {
      if (value === oldValue || this.ignoreRangeStart) return;
      this.updateRangeStartDirectInputField(value);
    });
    this.$watch("rangeEnd", (value, oldValue) => {
      if (value === oldValue || this.ignoreRangeEnd) return;
      this.updateRangeEndDirectInputField(value);
    });
    this.$nextTick(() => {
      this.ready = true;
    });
  },
  normalize(value) {
    const ratio = (100 - 0) / (this.max - this.min);
    return (value - this.min) * ratio + 0;
  },
  updateRangeStartDirectInputField(value, triggerChange = true) {
    this.$refs.rangeStartDirectInputField.value = (value / 100).toString();
    this.$refs.rangeStartDirectInputField.dispatchEvent(new Event("remask"));
  },
  updateRangeEndDirectInputField(value, triggerChange = true) {
    this.$refs.rangeEndDirectInputField.value = (value / 100).toString();
    this.$refs.rangeEndDirectInputField.dispatchEvent(new Event("remask"));
  },
  handleRangeStartDirectInputFieldInput() {
    this.ignoreRangeStart = true;
    this.rangeStart = this.$el.value.replaceAll(/\D/g, "") * 100;
    this.$nextTick(() => {
      this.ignoreRangeStart = false;
    });
    this.$refs.rangeStartFormField.dispatchEvent(
      new CustomEvent("indirect-change")
    );
  },
  handleRangeEndDirectInputFieldInput() {
    this.ignoreRangeEnd = true;
    this.rangeEnd = this.$el.value.replaceAll(/\D/g, "") * 100;
    this.$nextTick(() => {
      this.ignoreRangeEnd = false;
    });
    this.$refs.rangeEndFormField.dispatchEvent(
      new CustomEvent("indirect-change")
    );
  },
  handleRangeStartDirectInputFieldChange() {
    this.$refs.rangeStartFormField.dispatchEvent(new Event("change"));
  },
  handleRangeEndDirectInputFieldChange() {
    this.$refs.rangeEndFormField.dispatchEvent(new Event("change"));
  },
  handleRangeStartControlChange() {
    this.$refs.rangeStartFormField.dispatchEvent(new Event("change"));
  },
  handleRangeEndControlChange() {
    this.$refs.rangeEndFormField.dispatchEvent(new Event("change"));
  },
  handleRangeCenterControlChange() {
    this.$refs.rangeStartFormField.dispatchEvent(new Event("change"));
  }
});

// _src/js/components/variant-drop-down.js
var variant_drop_down_default = () => ({
  expanded: false,
  toggle() {
    if (this.expanded) {
      this.close();
      return;
    }
    this.$refs.button.focus();
    this.expanded = true;
    this.$refs.panel.style.display = "";
    const selectedEl = this.$refs.panel.querySelector("[aria-selected]");
    if (selectedEl) {
      this.$focus.focus(selectedEl);
    } else {
      this.$focus.within($refs.panel).first();
    }
  },
  close(focusAfter) {
    if (!this.expanded) return;
    this.expanded = false;
    this.$refs.panel.style.display = "none";
    if (focusAfter) {
      this.$focus.focus(focusAfter);
    }
  }
});

// _src/js/components/quantity.js
var quantity_default2 = () => ({
  quantity: 1,
  init() {
    // Initialize quantity from the input field's current value
    const inputValue = parseInt(this.$refs.quantityInput.value);
    if (!isNaN(inputValue) && inputValue > 0) {
      this.quantity = inputValue;
    }
    console.log('Quantity component initialized:', this.quantity, 'Input value:', this.$refs.quantityInput.value);
    // Watch for quantity changes and ensure input value stays in sync
    this.$watch('quantity', (value) => {
      console.log('Quantity changed to:', value, 'Input value:', this.$refs.quantityInput.value);
      if (this.$refs.quantityInput && this.$refs.quantityInput.value != value) {
        this.$refs.quantityInput.value = value;
        console.log('Synced input value to:', value);
      }
    });
    // Only reset quantity on product pages, not in cart
    const isProductQuantity = this.$refs.quantityInput.getAttribute('name') === 'quantity';
    if (isProductQuantity) {
      const resetHandler = () => {
        this.quantity = 1;
        this.$refs.quantityInput.value = 1;
      };
      document.body.addEventListener('baseline:productform:success', resetHandler);
    }
  },
  ...quantity_default
});

// _src/js/components/modal-cart.js
var modal_cart_default = ({ openOnAddToCart }) => {
  return {
    init() {
      if (openOnAddToCart === true) {
        document.body.addEventListener("baseline:cart:afteradditem", () => {
          Alpine.store("modals").closeAll();
          Alpine.store("modals").open("cart");
        });
      }
      Alpine.store("modals").register("cart", "rightDrawer");
    }
  };
};

// _src/js/components/rte.js
var rte_default = () => ({
  init() {
    this.$root.querySelectorAll("table").forEach((tableEl) => {
      const wrapper = wrap(tableEl);
      wrapper.classList.add("rte__table");
    });
    const iframeSelector = `iframe[src*="youtube.com"],iframe[src="vimeo"]`;
    this.$root.querySelectorAll(iframeSelector).forEach((extVideoEl) => {
      const wrapper = wrap(extVideoEl);
      wrapper.classList.add("rte__external-video");
    });
  }
});

// _src/js/components/sidebar.js
var sidebar_default = () => ({
  boundOnSectionSelect: null,
  boundOnSectionDeselect: null,
  init() {
    if (Shopify.designMode) {
      this.setUpDesignMode();
    }
  },
  setUpDesignMode() {
    this.boundOnSectionSelect = this.onSectionSelect.bind(this);
    this.boundOnSectionDeselect = this.onSectionDeselect.bind(this);
    document.addEventListener(
      "shopify:section:select",
      this.boundOnSectionSelect
    );
    document.addEventListener(
      "shopify:section:deselect",
      this.boundOnSectionDeselect
    );
  },
  onSectionSelect(e) {
    if (!e.target.contains(this.$root)) return;
    Alpine.store("modals").open("sidebar");
  },
  onSectionDeselect(e) {
    if (!e.target.contains(this.$root)) return;
    Alpine.store("modals").close("sidebar");
  },
  destroy() {
    document.removeEventListener(
      "shopify:section:select",
      this.boundOnSectionSelect
    );
    document.removeEventListener(
      "shopify:section:deselect",
      this.boundOnSectionDeselect
    );
  }
});

// _src/js/components/table.js
var table_default = () => ({
  sortCol: 0,
  sortOrder: "asc",
  sortOpen: false,
  originalItems: [],
  mobileSortLabel: "",
  initialSortComplete: false,
  init() {
    this.originalItems = [...this.$refs.tableData.children];
    this.mobileSortLabel = this.$refs.tableHeader.children[this.sortCol].dataset.sortLabel;
    this.sortItems();
    this.initialSortComplete = true;
  },
  sort(colIndex) {
    this.sortOrder = this.sortCol === colIndex && this.sortOrder === "asc" ? "desc" : "asc";
    this.sortCol = colIndex;
    this.sortItems();
  },
  mobileSort(colIndex, order) {
    this.sortOrder = order;
    this.sortCol = colIndex;
    this.sortItems();
    this.mobileSortLabel = this.$refs.tableHeader.children[this.sortCol].dataset.sortLabel;
    this.sortOpen = false;
  },
  sortItems() {
    const tableContainer = this.$refs.tableData;
    const rows = tableContainer.children;
    const rowsArray = Array.from(rows);
    rowsArray.sort((a, b) => {
      const aSortValue = a.querySelector(`[data-index="${this.sortCol}"]`).dataset.sortValue.toLowerCase();
      const bSortValue = b.querySelector(`[data-index="${this.sortCol}"]`).dataset.sortValue.toLowerCase();
      if (!isNaN(aSortValue) && !isNaN(bSortValue)) {
        return this.sortOrder === "asc" ? aSortValue - bSortValue : bSortValue - aSortValue;
      }
      if (isBooleanString(aSortValue) && isBooleanString(bSortValue)) {
        const aSortBoolValue = stringToBoolean(aSortValue);
        const bSortBoolValue = stringToBoolean(bSortValue);
        if (aSortBoolValue === bSortBoolValue) {
          return 0;
        }
        if (aSortBoolValue) {
          return this.sortOrder === "asc" ? -1 : 1;
        } else {
          return this.sortOrder === "asc" ? 1 : -1;
        }
      }
      if (aSortValue < bSortValue) {
        return this.sortOrder === "asc" ? -1 : 1;
      }
      if (aSortValue > bSortValue) {
        return this.sortOrder === "asc" ? 1 : -1;
      }
      return 0;
    });
    tableContainer.innerHTML = "";
    rowsArray.forEach((row) => tableContainer.appendChild(row));
  },
  restoreOriginalItems() {
    const tableContainer = this.$refs.tableData;
    tableContainer.innerHTML = "";
    this.originalItems.forEach((item) => tableContainer.appendChild(item));
  }
});

// _src/js/components/slideshow.js
var slideshow_default = ({
  autoplay = false,
  autoplayInterval = null,
  mode = "slideshow",
  gap = null,
  onlyIfNeeded = false
}) => ({
  autoplay,
  autoplayInterval,
  playing: false,
  splide: null,
  rate: 0,
  mode,
  gap,
  onlyIfNeeded,
  maxLgBreakpointMQL: window.matchMedia("(max-width: 1023px)"),
  init() {
    if (typeof Splide === "undefined") {
      console.error(
        "The Slideshows component requires a Splide object to be defined in the global scope"
      );
      return;
    }
    this.initSplide();
    if (this.onlyIfNeeded) {
      this.destroyOrInitIfNeeded();
      this.maxLgBreakpointMQL.addEventListener("change", (e) => {
        this.destroyOrInitIfNeeded();
      });
    }
    if (Shopify.designMode) {
      this._setUpDesignModeHandlers();
    }
    document.addEventListener("dev:hotreloadmutation", async () => {
      if (!Shopify.designMode) {
        this.splide.destroy();
        await this.$nextTick();
        this.initSplide();
      }
    });
  },
  initSplide() {
    const options = {
      arrows: true,
      pagination: true,
      rewind: true,
      speed: 600,
      start: parseInt(this.$root.dataset.start, 10) - 1 || 0,
      interval: this.autoplayInterval,
      autoplay: this.autoplay,
      drag: !this.autoplay
    };
    if (this.mode === "carousel") {
      options.autoWidth = true;
    }
    if (this.gap) {
      options.gap = this.gap;
    }
    this.splide = new Splide(this.$root, options);
    if (options.autoplay) {
      this.splide.on("autoplay:play", () => {
        this.playing = true;
      });
      this.splide.on("autoplay:pause", () => {
        this.playing = false;
      });
      this.splide.on("autoplay:playing", (rate) => {
        this.rate = rate;
      });
    }
    this.splide.mount();
  },
  destroyOrInitIfNeeded() {
    const slideEls = Array.from(
      this.$root.querySelectorAll(".splide__slide")
    );
    const totalSlidesWidth = slideEls.reduce(
      (totalWidth, slideEl) => totalWidth + slideEl.getBoundingClientRect().width,
      0
    );
    const totalGridlinesWidth = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--gridline-width"
      )
    ) * (slideEls.length - 1);
    const totalContentWidth = totalSlidesWidth + totalGridlinesWidth;
    if (totalContentWidth <= this.$root.getBoundingClientRect().width) {
      if (splideIsNotDestroyed(this.splide)) this.splide.destroy();
    } else {
      if (!splideIsNotDestroyed(this.splide)) this.initSplide();
    }
  },
  _setUpDesignModeHandlers() {
    this.$root.addEventListener("slideshow-go", (e) => {
      if (!e.detail) return;
      this.splide.go(parseInt(e.detail, 10));
    });
  }
});

// _src/js/components/promo-popup.js
var promo_popup_default = ({ delay, frequency, enabled }) => ({
  delay,
  frequency,
  enabled,
  sectionId: null,
  storageKey: null,
  boundOnSectionSelect: null,
  boundOnSectionDeselect: null,
  async init() {
    this.sectionId = this.$root.id;
    this.storageKey = `switch-popup-${this.sectionId}`;
    if (window.location.pathname === "/challenge") return;
    if (this.enabled) {
      if (Shopify.designMode) {
        Alpine.store("modals").removeExistingContents("promo", "#promoPopup");
      }
      initTeleport(this.$root);
      Alpine.store("modals").register("promoPopup", "promo");
    }
    document.body.addEventListener("promo-is-closed", (e) => {
      setExpiringStorageItem(
        this.storageKey,
        "shown",
        daysInMs(this.frequency)
      );
    });
    const popupContent = this.$refs.teleported.content.querySelector("template").content;
    const hasErrors = Boolean(popupContent.querySelector("[data-errors]"));
    const hasSuccessMessage = Boolean(
      popupContent.querySelector("[data-success-message]")
    );
    if (hasSuccessMessage || hasErrors) {
      this.open();
      this.clearSuccessParams();
      setExpiringStorageItem(this.storageKey, "shown", daysInMs(200));
    }
    if (!Shopify.designMode) {
      if (getExpiringStorageItem(this.storageKey) !== "shown") {
        setTimeout(() => {
          this.open();
          const escapeHandler = (e) => {
            if (e.code !== "Escape") return;
            this.$store.modals.close("promoPopup");
            document.body.removeEventListener("keydown", escapeHandler);
          };
          document.body.addEventListener("keydown", escapeHandler);
        }, this.delay * 1e3);
      }
    } else {
      if (window.theme.designMode.selected === this.sectionId) {
        if (this.enabled === true) {
          this.open();
        } else {
          Alpine.store("modals").close("promoPopup");
        }
      }
      this.boundOnSectionSelect = this.onSectionSelect.bind(this);
      this.boundOnSectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener(
        "shopify:section:select",
        this.boundOnSectionSelect
      );
      document.addEventListener(
        "shopify:section:deselect",
        this.boundOnSectionDeselect
      );
    }
  },
  open() {
    this.$store.modals.open("promoPopup");
    this.$focus.first();
  },
  onSectionSelect(e) {
    if (!e.target.contains(this.$root)) return;
    if (!this.enabled) return;
    this.open();
  },
  onSectionDeselect(e) {
    if (!e.target.contains(this.$root)) return;
    this.$store.modals.close("promoPopup");
  },
  clearSuccessParams() {
    const updatedParams = new URLSearchParams(window.location.search);
    if (updatedParams.has("customer_posted")) {
      updatedParams.delete("customer_posted");
    }
    let newURL;
    if (updatedParams.toString().length > 0) {
      newURL = `${window.location.pathname}?${updatedParams.toString()}`;
    } else {
      newURL = window.location.pathname;
    }
    history.replaceState("", document.title, newURL);
  },
  destroy() {
    document.removeEventListener(
      "shopify:section:select",
      this.boundOnSectionSelect
    );
    document.removeEventListener(
      "shopify:section:deselect",
      this.boundOnSectionDeselect
    );
  }
});

// _src/js/elements/scrolling-items-container.js
var ScrollingItemsContainer = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (!this.isConnected) return;
    this.scrollingItemsEl = this.firstElementChild;
    this.resizeObserver = new ResizeObserver(
      debounce((entries) => {
        const entry = entries[0];
        if (entry.contentRect.width === this.lastWidth) {
          return;
        }
        this.lastWidth = entry.contentRect.width;
        this.scrollingItemsEl.adjustScrollingItemsSpeed();
        this.scrollingItemsEl.makeClones();
      }, 150)
    );
    this.resizeObserver.observe(this);
    this.addEventListener("scrolling-items:change", () => {
      this.scrollingItemsEl.adjustScrollingItemsSpeed();
      this.scrollingItemsEl.makeClones();
    });
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:unload", (e) => {
        if (e.target.contains(this)) {
          this.resizeObserver.disconnect();
        }
      });
    }
  }
  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }
};

// _src/js/elements/scrolling-items.js
var ScrollingItems = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (!this.isConnected) return;
    this.adjustScrollingItemsSpeed();
    this.makeClones();
  }
  adjustScrollingItemsSpeed() {
    const referenceWidth = 1024;
    document.documentElement.style.setProperty(
      "--global-scrolling-items-speed-multiplier",
      window.innerWidth / referenceWidth
    );
  }
  makeClones() {
    let i = 0;
    const fallbackContentEl = this.querySelector("noscript");
    if (fallbackContentEl) {
      this.querySelector("noscript").remove();
    }
    const scrollingItemsSurfaceEl = this.querySelector(
      "scrolling-items-surface"
    );
    const originalContentEl = this.querySelector("scrolling-items-content");
    if (!scrollingItemsSurfaceEl || !originalContentEl) {
      return;
    }
    const originalContentWidth = originalContentEl.getBoundingClientRect().width;
    if (originalContentWidth === 0) {
      return;
    }
    const totalClonesNeeded = 2 * Math.ceil(window.innerWidth * 2 / originalContentWidth / 2);
    const addClone = () => {
      const clone = originalContentEl.cloneNode(true);
      scrollingItemsSurfaceEl.append(clone);
    };
    while (scrollingItemsSurfaceEl.children.length !== totalClonesNeeded) {
      if (totalClonesNeeded === Infinity || Number.isNaN(totalClonesNeeded) || i > 1e3) {
        console.error(
          `Baseline: Scrolling items: Something went wrong inside the scrolling items layout function`,
          {
            originalContentWidth,
            windowInnerWidth: window.innerWidth,
            totalExistingClones: scrollingItemsSurfaceEl.children.length,
            totalClonesNeeded
          }
        );
        break;
      }
      if (scrollingItemsSurfaceEl.children.length > totalClonesNeeded) {
        scrollingItemsSurfaceEl.removeChild(scrollingItemsSurfaceEl.lastChild);
      } else {
        addClone();
      }
    }
    this.style.setProperty(
      "--local-scrolling-items-speed-multiplier",
      this.getBoundingClientRect().width / window.innerWidth
    );
  }
};

// node_modules/@shopify/theme-currency/currency.js
var moneyFormat = "${{amount}}";
function formatMoney2(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;
  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

// node_modules/@switchthemes/live-region/index.js
function liveRegion(content, clear) {
  clearTimeout(window.liveRegionTimeout);
  let region = document.getElementById("screenreader-announce");
  region.innerHTML = content;
  window.liveRegionTimeout = setTimeout(() => {
    region.innerHTML = "";
  }, 3e3);
}
function cartLiveRegion(item) {
  const templateString = theme.strings.update + ": [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]";
  function _liveRegionContent() {
    let liveRegionContent = templateString;
    liveRegionContent = liveRegionContent.replace("[QuantityLabel]", theme.strings.quantity).replace("[Quantity]", item.quantity);
    let regularLabel = "";
    let regularPrice = formatMoney2(item.original_line_price, theme.moneyFormat);
    let discountLabel = "";
    let discountPrice = "";
    let discountInformation = "";
    if (item.original_line_price > item.final_line_price) {
      regularLabel = theme.strings.regularTotal;
      discountLabel = theme.strings.discountedTotal;
      discountPrice = formatMoney2(item.final_line_price, theme.moneyFormat);
      discountInformation = theme.strings.priceColumn;
    }
    liveRegionContent = liveRegionContent.replace("[Regular]", regularLabel).replace("[$$]", regularPrice).replace("[DiscountedPrice]", discountLabel).replace("[$]", discountPrice).replace("[PriceInformation]", discountInformation).replace("  .", "").trim();
    return liveRegionContent;
  }
  liveRegion(_liveRegionContent(), true);
}
function variantLiveRegion(variant) {
  const templateString = "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";
  function _getBaseUnit() {
    if (variant.unit_price_measurement.reference_value === 1) {
      return variant.unit_price_measurement.reference_unit;
    }
    return variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
  }
  function _liveRegionContent() {
    let liveRegionContent = templateString;
    const availability = variant.available ? "" : theme.strings.soldOut + ",";
    liveRegionContent = liveRegionContent.replace(
      "[Availability]",
      availability
    );
    let regularLabel = "";
    let regularPrice = formatMoney2(variant.price, theme.moneyFormat);
    let saleLabel = "", salePrice = "", unitLabel = "", unitPrice = "";
    if (variant.compare_at_price > variant.price) {
      regularLabel = theme.strings.regularPrice;
      regularPrice = formatMoney2(variant.compare_at_price, theme.moneyFormat);
      saleLabel = theme.strings.sale;
      salePrice = formatMoney2(variant.price, theme.moneyFormat);
    }
    if (variant.unit_price) {
      unitLabel = theme.strings.unitPrice;
      unitPrice = formatMoney2(variant.unit_price, theme.moneyFormat) + " " + theme.strings.unitPriceSeparator + " " + _getBaseUnit();
    }
    liveRegionContent = liveRegionContent.replace("[Regular]", regularLabel).replace("[$$]", regularPrice).replace("[Sale]", saleLabel).replace("[$]", salePrice).replace("[UnitPrice]", unitLabel).replace("[$$$]", unitPrice).replace("  .", "").trim();
    return liveRegionContent;
  }
  liveRegion(_liveRegionContent(), false);
}

// node_modules/@switchthemes/islands/index.js
var DataIsland = class extends HTMLElement {
  constructor() {
    super();
  }
  async connectedCallback() {
    if (!this.isConnected) return;
    this._x_ignore = true;
    let onVisible = false, onIdle = false, onInteraction = false;
    let onVisibleModifier;
    if (this.hasAttribute("on")) {
      const onAttribute = this.getAttribute("on");
      if (onAttribute === "idle") {
        onIdle = true;
      } else if (onAttribute.endsWith("visible")) {
        onVisible = true;
        onVisibleModifier = onAttribute.includes(":") ? onAttribute.split(":")[0] : null;
      } else if (onAttribute === "interaction") {
        onInteraction = true;
      }
    } else {
      onVisible = true;
    }
    if (onIdle) {
      await this.idle();
    } else if (onVisible) {
      await this.visible(onVisibleModifier);
    } else if (onInteraction) {
      await this.interaction();
    }
    this.hydrate();
  }
  idle() {
    return new Promise((resolve) => {
      requestIdleCallback(() => {
        resolve();
      });
    });
  }
  interaction() {
    const events = ["touchstart", "click"];
    return new Promise((resolve) => {
      const onInteractionListener = (event) => {
        for (const eventName of events) {
          this.removeEventListener(eventName, onInteractionListener);
        }
        resolve();
      };
      for (const eventName of events) {
        this.addEventListener(eventName, onInteractionListener);
      }
    });
  }
  visible(modifier = null) {
    const options = {
      rootMargin: "25%"
    };
    if (modifier) {
      switch (modifier) {
        case "before":
          options.rootMargin = "125%";
          break;
        case "mostly":
          options.rootMargin = "0px";
          options.threshold = 0.75;
          break;
        case "fully":
          options.rootMargin = "0px";
          options.threshold = 1;
          break;
      }
    }
    return new Promise((resolve) => {
      const io = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) return;
          resolve();
          io.disconnect();
          break;
        }
      }, options);
      if (getComputedStyle(this).display === "contents") {
        for (const childEl of this.children) {
          io.observe(childEl);
        }
      } else {
        io.observe(this);
      }
    });
  }
  // disconnectedCallback() {
  // }
  async hydrate() {
    const componentName = this.getAttribute("x-data")?.trim().split("(")[0];
    if (componentName && !componentName.startsWith("{") && this.hasAttribute("src")) {
      await importOrImportShim(this.getAttribute("src"));
    }
    await this.parentHydration();
    if (!window.Alpine) await window.alpineInitPromise();
    if (!window.alpineIsStarted) await window.alpineStartedPromise();
    delete this._x_ignore;
    await Alpine.nextTick();
    Alpine.initTree(this);
    this.setAttribute("ready", "");
  }
  parentHydration() {
    const parentDeferredEl = this.parentElement.closest(
      "data-island:not([ready])"
    );
    if (!parentDeferredEl) {
      return;
    }
    return new Promise((resolve, reject) => {
      if (parentDeferredEl) {
        const parentObserver = new MutationObserver(
          (mutationsList, observer) => {
            if (parentDeferredEl.hasAttribute("ready")) {
              observer.disconnect();
              resolve();
            }
          }
        );
        parentObserver.observe(parentDeferredEl, {
          attributes: true,
          attributeFilter: ["ready"]
        });
      }
    });
  }
};
function init() {
  if (!(HTMLScriptElement.supports && HTMLScriptElement.supports("importmap"))) {
    window.importOrImportShim = (name) => importShim(name);
  } else {
    window.importOrImportShim = (name) => import(name);
  }
  window.alpineIsInitialized = false;
  window.alpineIsStarted = false;
  document.addEventListener("alpine:initialized", () => {
    window.alpineIsInitialized = true;
  });
  document.addEventListener("switch:alpine:started", () => {
    window.alpineIsStarted = true;
  });
  window.alpineInitPromise = () => {
    return new Promise((resolve) => {
      if (window.alpineIsInitialized) {
        resolve();
      }
      document.addEventListener("alpine:initialized", () => {
        resolve();
      });
    });
  };
  window.alpineStartedPromise = () => {
    return new Promise((resolve) => {
      if (window.alpineIsStarted) {
        resolve();
      }
      document.addEventListener("switch:alpine:started", () => {
        resolve();
      });
    });
  };
  if (!customElements.get("data-island")) {
    customElements.define("data-island", DataIsland);
  }
}

// _src/js/global.js
var { intersect, focus, collapse, morph } = AlpinePlugins;
Alpine2.plugin(intersect);
Alpine2.plugin(focus);
Alpine2.plugin(collapse);
Alpine2.plugin(morph);
Alpine2.plugin(fetched_fragment_default);
Alpine2.plugin(html_if_set_default);
Alpine2.plugin(mask_default);
window.Alpine = Alpine2;
window.Spruce = Alpine2;
init();
window.Splide = Splide2;
window.liveRegion = liveRegion;
window.variantLiveRegion = variantLiveRegion;
window.cartLiveRegion = cartLiveRegion;
document.addEventListener("alpine:init", () => {
  Alpine2.store("modals", modals_default);
  Alpine2.store("cartCount", cart_count_default);
  Alpine2.store("favorites", favorites_default);
  Alpine2.store("chatQuote", chat_quote_default);
});
Alpine2.data("AgeCheck", age_check_default);
Alpine2.data("FreeShippingBar", free_shipping_bar_default);
Alpine2.data("CartItems", cart_items_default);
Alpine2.data("CartItem", cart_item_default);
Alpine2.data("CartItemQuantity", cart_item_quantity_default);
Alpine2.data("CartFooter", cart_footer_default);
Alpine2.data("CartNote", cart_note_default);
Alpine2.data("Header", header_default);
Alpine2.data("Video", video_default);
Alpine2.data("ProductMediaVideo", product_media_video_default);
Alpine2.data("HTMLVideo", html_video_default);
Alpine2.data("Filterable", filterable_default);
Alpine2.data("RangeControl", range_control_default);
Alpine2.data("VariantDropDown", variant_drop_down_default);
Alpine2.data("Quantity", quantity_default2);
Alpine2.data("Sidebar", sidebar_default);
Alpine2.data("Table", table_default);
Alpine2.data("ModalCart", modal_cart_default);
Alpine2.data("RTE", rte_default);
Alpine2.data("Slideshow", slideshow_default);
Alpine2.data("PromoPopup", promo_popup_default);
Alpine2.data("FavoritesDrawer", favorites_drawer_default);
Alpine2.data("QuoteRequestForm", quote_request_form_default);
Alpine2.data("BookRequestForm", book_request_form_default);
if (!customElements.get("scrolling-items-container")) {
  customElements.define("scrolling-items-container", ScrollingItemsContainer);
}
if (!customElements.get("scrolling-items")) {
  customElements.define("scrolling-items", ScrollingItems);
}
setTimeout(() => {
  Alpine2.start();
  document.dispatchEvent(new CustomEvent("switch:alpine:started"));
});
console.log('Baseline theme (3.3.1) by SWITCH | Make the switch: https://switchthemes.co');

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
